import React, { useEffect, useState, useRef } from 'react';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { ConfigServer } from "../../data/config";
import moment from 'moment';
import { useModal } from "react-morphing-modal";
import { usePaginationCash } from "../pagination/usePaginationCash";
import { getAllBranches } from '../../services/commercialLine/commercialLine'
import { getDetailCash } from '../../services/cashFlow/cashFlow'
import { createCash, getGlobalDetail } from '../../services/cashFlow/cashFlow'
import { useHistory } from 'react-router-dom';
import { labcen, cedimi, pyrsa, insan, semlab, almas, qfb, phersu } from '../../constant/globalConstantsTypeClients'
import * as XLSX from "xlsx-js-style";



export const useCash = () => {

    // * GLOBALES
    // * NEW COMMIT
    let _commercialLine = localStorage.getItem('CommercialLineShort');
    let _nameUser = localStorage.getItem('nameUser');
    let _branchName = localStorage.getItem('branchName');
    let id_branch = localStorage.getItem('branchId');
    let _type_client = localStorage.getItem('url_helen');


    const history = useHistory();



    const [viewTab, setViewTab] = useState(1);
    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    //indicadores
    const [cancell, setCancell] = useState(0);
    const [discountT, setDiscountT] = useState(0);
    const [orderFirst, setOrderFirst] = useState(0);
    const [orderLast, setOrderLast] = useState(0);
    const [idCashFlow, setIdCashFlow] = useState(0);
    const [totalCancell, setTotalCancell] = useState(0);
    //historic cash flow
    const [dataHistoric, setDataHistoric] = useState([]);
    const [dateInit, setDateInit] = useState(new moment().format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(new moment().format('YYYY-MM-DD'));
    const [typeModal, setTypeModal] = useState("ViewCas");
    const [modalC, setModalC] = useState(false);
    const [typeAmoun, setTypeAmoun] = useState([]);
    const [amountfin, setAmountfin] = useState([]);
    const [totalPaymets, setTotalPaymets] = useState(0);
    const numberCash = 8;
    const [branches, setBranches] = useState([]);
    const [dataUser, setDataUser] = useState([])
    const [sumPayMethods, setSumPayMethods] = useState(0)
    const [totalPatients, setTotalPatients] = useState(0);

    //*CONFIGURATION FINANCE
    let _valid_Finance = localStorage.getItem('finance');
    let _finance2 = localStorage.getItem('finance_view');
    let _validationFinance = (_valid_Finance === "True" && _finance2 === "False") ? true : false

    //*PRINT TICKET
    const [loadingPrint, setLoadingPrint] = useState(false);

    //*DETAIL REPORT
    const [datafinally, setDatafinally] = useState([]);
    const [dataDevolution, setDataDevolution] = useState(0);
    const [listC, setListC] = useState(0)
    const [loadingCreate, setLoadingCreate] = useState(false)

    //*PRINT TICKET
    const [modalPrint, setModalPrint] = useState(false);

    //*PREVIEW CASH
    const [modalPreview, setModalPreview] = useState(false);


    //*FINAL REPORT 
    const [dataReport, setDataReport] = useState([]);
    const [key, setKey] = useState(0);
    const [dataPaymets, setDataPaymets] = useState([]);
    const [dataCancell, setDataCancell] = useState(0);
    const [dataDiscount, setDataDiscount] = useState(0);
    const [dataPatient, setDataPatient] = useState(0);
    const [dataMDiscount, setDataMDiscount] = useState(0);
    const [total_devolution, setTotal_devolution] = useState(0)
    const [loadingReport, setLoadingReport] = useState(false)


    const [dataUserReport, setDataUserReport] = useState([]);
    const [excelExport, setExcelExport] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null)

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    // * FLUJO B
    const [dataBonificacionCC, setDataBonificacionCC] = useState(0);



    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };


    const closeToastAlert = () => {
        setShowToast(false);
        setToastTitle("");
        setToastMessage("");
    };




    useEffect(() => {
        getAmount();
        handleHistoric(true);
        getDetailCreditCash();
        getBranches();
        getUserDetail()
    }, []);

    useEffect(() => {
        if (idCashFlow > 0) {
            if (_type_client === "https://cedimi.helen-sw.com") {
                downloadExcelCredits(idCashFlow);
                downloadExcelOthers(idCashFlow);
                printTicket(idCashFlow);
            } else {
                printTicket(idCashFlow);
                downloadExcel(idCashFlow);
            }
        }
    }, [idCashFlow, _type_client]);


    const toggleCash = () => {
        setModalC(!modalC);
    }

    //*REF
    const modalFullRef = useRef(null);


    //*FORM
    const [formCash, handleInputChangeCash, resetCash, handleUpdateValuesCash, handleSelectValuesCash] = useForm({
        capture_amount: "",
        comments: "",
        mDateRange1: "",
        mDateRange2: "",
        mSelectBranch: 0,
        ids_users: 0,
        ids_branches: 0,
        type_company: null
    });

    const {
        capture_amount,
        comments,
        mDateRange1,
        mDateRange2,
        mSelectBranch,
        type_company,
        ids_users
    } = formCash;

    //*PRINT TICKET
    const toggleModalPrint = () => {
        setModalPrint(!modalPrint);
    }

    const handleViewTickets = () => {
        toggleModalPrint()
    }

    //*PREVIEW CASH 
    const toggleModalPreview = () => {
        setModalPreview(!modalPreview);
    }

    const handleViewPreview = () => {
        toggleModalPreview()
    }



    //*OPEN FINAL REPORT
    const { close, modalProps, open } = useModal({
        onClose: () => setKey(key => key + 1),
        background: "#fff"

    });

    const handleReport = () => {
        open(modalFullRef);
    }


    //*HISTORIC CASH
    const previewCash = async (nim) => {
        setTypeModal("ViewCas");
        toggleCash();
    }


    //*ACTIONS MENU
    const navigatePrev = () => {
        let tab = viewTab;
        tab = tab - 1;
        setViewTab(tab);
        handleUpdateValuesCash({
            capture_amount: 0,
            input2: "",
            input3: "",
            input4: "",
            comments: ""
        })
    };


    // ? BRANCHES
    useEffect(() => {
        if (branches.length > 0) {

            let _find = branches.find(x => x.value === parseInt(id_branch))
            handleUpdateValuesCash({
                ...formCash,
                mSelectBranch: _find
            });
        }
    }, [branches]);


    const getBranches = async () => {
        const branches = await getAllBranches();
        if (branches !== null && branches.length > 0) {
            let _allOption = {
                value: 0,
                label: "TODAS LAS SUCURSALES"
            };

            let _newBranches = [_allOption];

            branches.forEach((branch) => {
                _newBranches.push({
                    value: branch.id_branch,
                    label: branch.name
                });
            });

            setBranches(_newBranches);
        } else {
            setBranches([]);
        }
    }

    // ? REPORT GLOBAL
    const getUserDetail = async () => {
        let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");

        const detailAmount = await getGlobalDetail(id_branch, _mfrom, _mto);

        if (detailAmount !== null) {

            let _arrayNew = [];

            let _amountGlobal = [
                { id_pay_method: 1, pay_method: "EFECTIVO", amount: 0 },
                { id_pay_method: 2, pay_method: "TARJETA DE CRÉDITO", amount: 0 },
                { id_pay_method: 4, pay_method: "TARJETA DE DÉBITO", amount: 0 },
                { id_pay_method: 8, pay_method: "TRANSFERENCIA ELECTRÓNICA DE FONDOS", amount: 0 },
                { id_pay_method: 28, pay_method: "FICHA DE DEPOSITO", amount: 0 },
                { id_pay_method: 10, pay_method: "CREDITO", amount: 0 }
            ];

            const companyNamesMap = {};

            detailAmount.workOrderDetailCash.forEach((_find, _key) => {
                if (_valid_Finance === "True") {
                    if (_finance2 === "False") {
                        if (_find.complete_information === "True") {
                            return;
                        }
                    }
                }


                if (_find.id_user !== null && _find.id_user !== 0) {
                    const companyName = _find.user;

                    if (!companyNamesMap.hasOwnProperty(companyName)) {
                        companyNamesMap[companyName] = true;
                        const nuevo = {
                            value: _find.id_user,
                            label: companyName,
                        };
                        setDataUser(prevDataUser => [...prevDataUser, nuevo]);
                    }
                }

                let { nim, fech, name, company, status, user, id_user, ajuste, paid, fech_Adjust, fech_admision, is_invoice, name_branches, amountDiscount, id_work_order } = _find;

                let payment = {
                    creditCard: _find.nameMethod === "TARJETA DE CRÉDITO" ? _find.amount : 0,
                    cash: _find.nameMethod === "EFECTIVO" ? _find.amount : 0,
                    debitCard: _find.nameMethod === "TARJETA DE DÉBITO" ? _find.amount : 0,
                    electronicTransfer: _find.nameMethod === "TRANSFERENCIA ELECTRÓNICA DE FONDOS" ? _find.amount : 0,
                    credit: _find.nameMethod === "CREDITO" ? _find.amount : 0,
                    deposit: _find.nameMethod === "FICHA DE DEPOSITO" ? _find.amount : 0,
                };

                let existingOrderIndex = _arrayNew.findIndex(objeto => objeto.nim === _find.nim);



                if (existingOrderIndex !== -1) {
                    if (!_find.ajuste) {
                        _arrayNew[existingOrderIndex].amount += _find.amount;
                    }
                    Object.keys(payment).forEach(method => {
                        _arrayNew[existingOrderIndex][method] += payment[method];
                    });
                } else {
                    _arrayNew.push({
                        ...payment,
                        nim,
                        hour: fech,
                        namePatiente: name,
                        name_branches: name_branches,
                        type: company ? "Empresas" : "P.General",
                        status: status === 0 ? "Cancelado" : "Vigente",
                        method: _find.nameMethod,
                        amount: (!_find.ajuste ? _find.amount : 0),
                        user,
                        id_user,
                        is_fullPaid: paid === false ? "PENDIENTE" : "LIQUIDADO",
                        ajuste,
                        paid,
                        fech_Adjust,
                        fech_admision,
                        is_invoice,
                        amountDiscount, id_work_order,
                        typeClientUser: _find.is_micro ? company ? _find.name_company : name : name


                    });
                }

                Object.keys(payment).forEach(method => {
                    if (_find.status === 0) {
                        return;
                    }

                    let id_pay_method = _find.id_pay_method;
                    let methodAmount = payment[method];

                    let globalIndex = _amountGlobal.findIndex(item => item.id_pay_method === id_pay_method);

                    if (globalIndex !== -1) {
                        _amountGlobal[globalIndex].amount += methodAmount;
                    }
                });
            });
            setDataUserReport(_arrayNew);
        } else setDataUserReport([]);

    }

    //? DETAIL CASH 
    const getAmount = async () => {
        const detailAmount = await getDetailCash(id_branch);

        if (detailAmount !== null) {

            let _restTotal = 0;
            let _sum_Global = 0;

            let workOrderCash = detailAmount?.workOrderCash ?? [];

            if (_type_client === labcen) {

                const keptWorkOrders = [];

                workOrderCash = Object.values(
                    workOrderCash.reduce((acc, item) => {
                        if (!acc[item.id_work_order]) {
                            acc[item.id_work_order] = [];
                        }
                        acc[item.id_work_order].push(item);
                        return acc;
                    }, {})
                ).flatMap(group => {

                    const workOrderId = group[0].id_work_order;

                    const hasCreditPaid = group.some(x =>
                        x.id_pay_method === 10 &&
                        x.fully_paid === true
                    );

                    const adjusted = group.filter(x =>
                        x.id_pay_method !== 10 &&
                        x.indicador === true
                    );

                    if (hasCreditPaid && adjusted.length > 0) {
                        keptWorkOrders.push(workOrderId);
                        return adjusted;
                    }

                    return group;
                });

            }


            const list = workOrderCash.reduce((_delete, _find) => {
                console.log("🚀 ~ getAmount ~ _find:", _find);

                if (_find.id_pay_method === 10 && _find.fully_paid === false) {
                    _restTotal += _find.amout;
                }

                _sum_Global += _find.amout;

                _delete.push({
                    id_pay_method: _find.id_pay_method,
                    pay_method: _find.pay_method,
                    total: Math.round(_find.amout),
                    fully_paid: _find.fully_paid
                });

                return _delete;
            }, []);


            setDatafinally(list);
            setListC(_restTotal);
            setSumPayMethods(_sum_Global);
            setCancell(detailAmount?.total_work_order_cancels);
            setDiscountT(Math.round(detailAmount?.total_discounts));
            setOrderFirst(detailAmount?.id_work_order_first);
            setOrderLast(detailAmount?.id_work_order_last);
            setTotalCancell(detailAmount?.cancell);
            setDataDevolution(detailAmount?.cancellAndIva);
            setTotalPatients(detailAmount?.total_work_orders);

        } else {
            setDatafinally([]);
            setListC(0);
            setSumPayMethods(0);
            setCancell(0);
            setDiscountT(0);
            setOrderFirst(0);
            setOrderLast();
            setTotalCancell();
            setDataDevolution(0);
            setTotalPatients(0);
        }
    };


    // ? GROUP BY METHODS    
    useEffect(() => {
        if (datafinally.length >= 1) {

            let _array = datafinally;
            let _nuevoObjeto = [];
            let _indexObject = [];

            _array.forEach(x => {
                if (!_nuevoObjeto.hasOwnProperty(x.pay_method)) {
                    _nuevoObjeto[x.pay_method] = {
                        Amount: 0,
                        AmountCapture: 0,
                    }
                    _indexObject.push(x.pay_method);
                }
                _nuevoObjeto[x.pay_method].Amount = _nuevoObjeto[x.pay_method].Amount + Math.round(x.total);
            })

            setAmountfin([_nuevoObjeto])
            setTypeAmoun([..._indexObject])
        }
        else {
            setTypeAmoun([]);
            setAmountfin([]);
        }

    }, [datafinally, dataDevolution, listC])

    const [visibleTicket, setVisibleTicket] = useState(false);

    const showModalTicket = () => {
        setVisibleTicket(true);
    };

    const hideModalTicket = () => {
        setVisibleTicket(false);
    };

    const [showAlert, setShowAlert] = useState(false);
    const [showAlert2, setShowAlert2] = useState(false);


    // ? CREATE CASH
    const saveCreate = async () => {


        if (formCash.capture_amount === "" && _type_client !== "https://insan.helen-sw.com2") {
            setShowAlert(true);
            return;
        }

        setLoadingCreate(true);
        let _arrayNew = amountfin[0] ?? 0;
        let _e = "EFECTIVO";
        let _notAmount = _arrayNew[_e];
        let _valid = _arrayNew[_e]?.Amount;

        // ? CONFIGURATION TYPE CLIENT
        let _valid_amount = _type_client === "https://insan.helen-sw.com2" ? _valid : formCash.capture_amount;

        if (
            _type_client === "https://cedimi.helen-sw.com" &&
            (parseFloat(formCash.capture_amount) < 0 ||
                (parseFloat(formCash.capture_amount) < (_valid - (_valid * 0.1)) && parseFloat(formCash.capture_amount) !== 0) ||
                parseFloat(formCash.capture_amount) > _valid)
        ) {

            setLoadingCreate(false);
            setShowAlert2(true);
            return;
        }
        const viewCash = await createCash(formCash.comments, _notAmount, _valid, _valid_amount, orderFirst, orderLast, id_branch);

        if (viewCash > 0) {
            setLoadingCreate(false);
            setIdCashFlow(viewCash);
            showToastAlert("success", "Corte de caja", "El corte de caja se realizo correctamente.");
            updateCash();
            hideModalTicket()
            handleHistoric(true)

        } else {
            setLoadingCreate(false);
            createSweet("warning", "warning", "No se generó correctamente el corte");
        }
    };

    const updateCash = () => {
        handleUpdateValuesCash({
            capture_amount: 0,
            input2: "",
            input3: "",
            input4: "",
            comments: ""
        })
        setViewTab(1);
        getAmount();
        setTypeAmoun([]);
        setAmountfin([]);
    }

    // ? PRINT TICKET
    const printTicket = async (id_cash_flow, _valid, _is_extemporaneous) => {
        if (id_cash_flow > 0) {
            setLoadingPrint(true);
            setLoadingReport(true);

            let token = localStorage.getItem("token");

            let _valid_url = _is_extemporaneous
                ? `/api/CashFlow/PrintTicket/${id_cash_flow}?mount_cancel=${dataDevolution}&is_extemporaneous=true`
                : `/api/CashFlow/PrintTicket/${id_cash_flow}?mount_cancel=${dataDevolution}`;

            await fetch(ConfigServer.serverUrl + _valid_url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
            })
                .then((response) => {
                    console.log("🚀 ~ printTicket ~ response:", response);

                    if (response.status !== 200) {
                        if (response.status === 409) {
                            showToastAlert("success", "Corte de caja", "No se puede imprimir cortes de dias pasados.");
                        } else {
                            showToastAlert("success", "Recibo", "No se genero correctamente el ticket.");

                        }

                        throw new Error("Respuesta inválida");
                    }

                    if (_valid) {
                        toggleModalPrint();
                    }

                    return response.blob();
                })
                .then((blob) => {
                    if (!blob) return;

                    var url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "ticket.pdf");
                    document.body.appendChild(link);
                    link.style.display = "none";
                    link.click();

                    setIdCashFlow(0);
                })
                .catch((error) => {
                    console.log("🚀 ~ printTicket ~ error:", error);
                })
                .finally(() => {
                    setLoadingPrint(false);
                    setLoadingReport(false);
                });
        }
    };

    // ? DOWNLOAD  CREDITS
    const downloadExcel = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }
        let token = localStorage.getItem("token");
        await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsCredits/${_idCash}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    showToastAlert("warning", "Ticket", "No se genero correctamente.");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Reporte Credito.xlsx");

                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }

    // ? OTHER 
    const downloadExcelCredits = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }

        setLoadingReport(true);

        let token = localStorage.getItem("token");
        try {
            const response = await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsCredits/${_idCash}`, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/vnd.ms-excel"
                })
            });

            if (response.status !== 200) {
                createSweet("warning", "warning", "No se descargo el archivo excel");
                setLoadingReport(false);
                return;
            }

            const blob = await response.blob();
            var url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte Saldo.xlsx");

            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

        } catch (error) {
            showToastAlert("warning", "Corte", "Ocurrió un error al descargar el archivo.");

        } finally {
            setLoadingReport(false);
        }
    };


    const downloadExcelOthers = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }

        setLoadingReport(true);

        let token = localStorage.getItem("token");
        try {
            const response = await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsOthers/${_idCash}`, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/vnd.ms-excel"
                })
            });

            if (response.status !== 200) {
                showToastAlert("warning", "Corte", "No se descargo el archivo excel.");
                setLoadingReport(false);
                return;
            }

            const blob = await response.blob();
            var url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte Contado.xlsx");

            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

        } catch (error) {
            showToastAlert("warning", "Corte", "Ocurrió un error al descargar el archivo.");
        } finally {
            setLoadingReport(false);
        }

    }


    const handleHistoric = async (filters = false) => {
        let _body = {};
        if (filters === false) {
            _body = {
                "date_init": "",
                "date_end": "",
                "type": "all"
            }
        } else {
            _body = {
                "date_init": dateInit,
                "date_end": dateEnd,
                "type": "filter"
            }
        }
        let _listTemp = await handleRequest("POST", "WorkOrder/DetailCash", "cash", _body);

        if (_listTemp !== null) {
            setDataHistoric([..._listTemp]);
        } else {
            setDataHistoric([]);
        }
    }

    const changeDate = (data, type) => {
        let _fecha = new moment(data._d).format('YYYY-MM-DD');
        if (type === "init") {
            setDateInit(_fecha)
        } else {
            setDateEnd(_fecha)
        }
    }

    const parseDateLocal = (dateString) => {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    };


    //*METHOD FINAL REPORT
    const getReport = (e, search = true) => {
        e.preventDefault();

        if (search) {
            if (!mDateRange1) {
                showToastAlert("warning", "Reporte Global", "Seleccione una fecha de inicio.");

                return;
            }
            if (!mDateRange2) {
                showToastAlert("warning", "Reporte Gloabl", "Seleccione una fecha de cierre.");
                return;
            }

            let query = "";
            let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _idBranch = mSelectBranch.value;
            let _typeUser = type_company == null ? null : type_company.value;
            let _idUser = ids_users.value;

            const start = parseDateLocal(_mfrom);
            const end = parseDateLocal(_mto);


            if (_type_client === pyrsa) {

                const monthDifference = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

                if (monthDifference > 5) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un máximo de 6 meses."
                    );
                    return;
                }

            } else if (
                _type_client === insan ||
                _type_client === semlab ||
                _type_client === almas ||
                _type_client === labcen ||
                _type_client === qfb ||
                _type_client === phersu
            ) {

                const monthDifference = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

                if (monthDifference > 7) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un máximo de 8 meses."
                    );
                    return;
                }

            } else {

                if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth()) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un único mes."
                    );
                    return;
                }
            }





            if (_mfrom !== "") {
                query += `${_idBranch}?date_from=${_mfrom}`;
            }

            if (_mto !== "") {
                query += `&date_to=${_mto}`;
            }

            if (_idBranch !== "" && _mfrom === "") {
                query += `${_idBranch}`;
                console.log("-");
            }

            if (type_company !== null && _mfrom.length === 0 && _mto.length === 0) {
                //  query += `?type_company=${_typeUser}`;   
                console.log("?");
            }

            if (type_company == null || _mfrom.length !== 0 || _mto.length !== 0) {
                if (_typeUser > 0) {
                    query += `&type_company=${_typeUser}`;
                    console.log("====");

                }
                else {
                    if (_idUser === undefined) {
                    }
                    else {
                        console.log("aqui pasa?3");
                        query += `&id_user=${_idUser}`;
                        setDataUser([{ "value": 0, "label": "Todos" }])
                    }
                }
            }

            //  if (type_company !== null || _mfrom.length === 0  || _mto.length === 0 ) {
            //     query += `&type_company=${_typeUser}`;  
            //     console.log("hhh");

            //  }
            getDetailCreditCash(true, query)
        }
    }


    //*END METHOD FINAL REPORT
    const getDetailCreditCash = async (_search = false, _filter) => {

        setLoading(true);
        var _listTmp = {};
        let _alterUrl = "";

        if (_search === false) {
            _listTmp = await handleRequest("GET", `WorkOrder/DetailCreditCash/${id_branch}` + _alterUrl, "Report");
        } else {
            _listTmp = await handleRequest("GET", `WorkOrder/DetailCreditCash/` + _filter, "Report");
        }

        console.log("🚀 ~ getDetailCreditCash ~ _listTmp:", _listTmp)
        if (_listTmp !== null) {

            setLoading(false);

            let _arrayNew = [];
            let startItems = 0;
            let endItems = numberCash;
            let aux = numberCash * currentPage1;

            endItems = aux;
            startItems = endItems - numberCash;

            // * LIST PAYMETHODS
            let _amountGlobal = [
                {
                    id_pay_method: 1,
                    pay_method: "EFECTIVO",
                    amount: 0
                },
                {
                    id_pay_method: 2,
                    pay_method: "TARJETA DE CRÉDITO",
                    amount: 0
                },
                {
                    id_pay_method: 4,
                    pay_method: "TARJETA DE DÉBITO",
                    amount: 0
                },
                {
                    id_pay_method: 8,
                    pay_method: "TRANSFERENCIA ELECTRÓNICA DE FONDOS",
                    amount: 0
                },
                {
                    id_pay_method: 28,
                    pay_method: "FICHA DE DEPOSITO",
                    amount: 0
                },
                {
                    id_pay_method: 10,
                    pay_method: "CREDITO",
                    amount: 0
                },
                {
                    id_pay_method: 31,
                    pay_method: "BONIFICACION",
                    amount: 0
                }
            ];


            let decimals = 2;
            const companyNamesMap = {};

            _listTmp.workOrderDetailCash.forEach(
                (_find, _key) => {

                    // ! SERIE B
                    const isBonificacionCC = _valid_Finance === "True" && _finance2 === "False" && _type_client === "https://cedimi.helen-sw.com" && _find.complete_information === "True" && _find.nameMethod === "EFECTIVO";

                    console.log("🚀 ~ getDetailCreditCash ~ isBonificacionCC:", isBonificacionCC);

                    let posicion = _key + 1;
                    let visibleTable = posicion > startItems && posicion <= endItems;

                    if (_find.id_user !== null && _find.id_user !== 0) {

                        const companyName = _find.user;

                        if (!companyNamesMap.hasOwnProperty(companyName)) {

                            companyNamesMap[companyName] = true;

                            const nuevo = { value: _find.id_user, label: companyName };

                            setDataUser(
                                prevDataUser => [
                                    ...prevDataUser,
                                    nuevo
                                ]
                            );
                        }
                    }


                    let {
                        nameMethod,
                        amount,
                        nim,
                        fech,
                        name,
                        company,
                        status,
                        user,
                        abreviationName,
                        abreviationPaternal,
                        abreviationMaternal,
                        id_user,
                        ajuste,
                        paid,
                        fech_Adjust,
                        fech_admision,
                        complete_information,
                        name_company,
                        is_invoice,
                        name_branches,
                        name_Preloaded_discount,
                        percentagePreloaded_discount,
                        id_company,
                        required_invoice,
                        flow_b,
                        rfc_receptor,
                        name_receptor,
                        folio_invoice,
                        emission_date_invoice,
                        age,
                        is_micro,
                        doctorName,
                        doctorCode,
                        seller,
                        priceDetails,
                        qc_reason,
                        name_agreenent,
                        name_devolution,
                        name_reason_devolution,
                        amount_devolution

                    } = _find;

                    let payment = {
                        creditCard: nameMethod === "TARJETA DE CRÉDITO" ? amount : 0,
                        cash: nameMethod === "EFECTIVO" ? (isBonificacionCC ? 0 : amount) : 0,
                        debitCard: nameMethod === "TARJETA DE DÉBITO" ? amount : 0,
                        electronicTransfer: nameMethod === "TRANSFERENCIA ELECTRÓNICA DE FONDOS" ? amount : 0,
                        credit: nameMethod === "CREDITO" ? amount : 0,
                        deposit: nameMethod === "FICHA DE DEPOSITO" ? amount : 0,
                        bonificacion: isBonificacionCC ? amount : (nameMethod === "BONIFICACION" ? amount : 0)
                    };

                    const _amountReport =
                        _type_client === "https://labcen.helen-sw.com" &&
                            _find.id_pay_method === 10
                            ? 0
                            : Number(amount ?? 0);

                    let existingOrderIndex = _arrayNew.findIndex(objeto => objeto.nim === _find.nim);

                    if (existingOrderIndex !== -1) {
                        // if (!_find.ajuste) {
                        //     _arrayNew[existingOrderIndex].amount += amount;
                        // }
                        if (!_find.ajuste) {
                            _arrayNew[existingOrderIndex].amount += _amountReport;
                        }

                        Object.keys(payment).forEach(
                            method => {
                                if (
                                    _arrayNew[existingOrderIndex][method] === undefined
                                ) {
                                    _arrayNew[existingOrderIndex][method] = 0;
                                }
                                _arrayNew[existingOrderIndex][method] += payment[method];
                            }
                        );

                        // * SERIE B
                        if (isBonificacionCC) {
                            _arrayNew[existingOrderIndex].method = "BONIFICACIÓN CC";
                            _arrayNew[existingOrderIndex].isBonificacionCC = true;
                        }

                    } else {

                        _arrayNew.push({
                            ...payment,
                            nim,
                            hour: fech,
                            namePatiente: name,
                            name_branches: name_branches,
                            type: company ? "Empresas" : "Público General",
                            status: status === 0 ? "Cancelado" : "Vigente",
                            method: isBonificacionCC ? "BONIFICACIÓN CC" : nameMethod,
                            amount_is_adjust:
                                _type_client === "https://labcen.helen-sw.com" && _find.ajuste === true
                                    ? Number(amount ?? 0)
                                    : 0,

                            // amount_is_adjust: ,
                            // amount: amount ?? 0,
                            amount: _amountReport,
                            user,
                            id_user,
                            is_fullPaid: paid === false ? "PENDIENTE" : "LIQUIDADO",
                            visibleTable,
                            is_adjustP: _find.is_adjustP,
                            abreviationName,
                            abreviationPaternal,
                            abreviationMaternal,
                            gatos: _find.status === 0 ? 0 : 1,
                            nameUserAdjust: _find.nameUserAdjust,
                            nameCommont: _find.nameCommont,
                            amountDiscount: company ? "" : _find.amountDiscount,
                            amountPercentag1: _find.amountPercentag1,
                            codeD: _find.codeD,
                            amountPercentag: _find.amountPercentag,
                            ajuste,
                            paid,
                            fech_Adjust,
                            fech_admision,
                            complete_information,
                            name_company,
                            is_invoice,
                            name_Preloaded_discount,
                            percentagePreloaded_discount,
                            id_company,
                            required_invoice,
                            flow_b,
                            isBonificacionCC,
                            rfc_receptor,
                            name_receptor,
                            folio_invoice,
                            emission_date_invoice,
                            age,
                            is_micro,
                            doctorName,
                            doctorCode,
                            seller,
                            priceDetails,
                            typeClientUser: _find.is_micro ? (company ? name_company : name) : name,
                            qc_reason,
                            name_agreenent,
                            name_devolution,
                            name_reason_devolution,
                            amount_devolution
                        });
                    }


                    Object.keys(payment).forEach(
                        method => {
                            if (_find.status === 0) {
                                return;
                            }

                            let id_pay_method = _find.id_pay_method;
                            let methodAmount = payment[method];

                            if (!_find.company) {

                                if (id_pay_method === 10 && _find.is_fullPaid) {
                                    return;
                                }
                            }

                            if (isBonificacionCC) {

                                if (method !== "cash") {
                                    return;
                                }

                                let bonificacionIndex = _amountGlobal.findIndex(item => item.id_pay_method === 31);

                                if (bonificacionIndex !== -1) {
                                    _amountGlobal[bonificacionIndex].amount += amount;
                                }
                                return;
                            }

                            let globalIndex = _amountGlobal.findIndex(item => item.id_pay_method === id_pay_method);

                            if (globalIndex !== -1) {
                                _amountGlobal[globalIndex].amount += methodAmount;
                            }
                        }
                    );
                }
            );

            let _totalCancell =
                _arrayNew.reduce(
                    (total, _movement) => {
                        return _movement.status === "Cancelado" ? total + _movement.amount : total;
                    },
                    0
                );


            let _totalDiscount =
                _arrayNew.reduce(
                    (total, _f) => {

                        let _finA = _f.amountDiscount;

                        if (_finA !== 0 && _finA !== "" && _finA !== null) {
                            return total + _f.amountDiscount;

                        } else {
                            return total;
                        }
                    },
                    0
                );


            let _totalGlobalMovements = 0;

            if (_type_client === "https://labcen.helen-sw.com") {
                _totalGlobalMovements = getTotalMovementsLabcen(_amountGlobal);
            } else {
                _totalGlobalMovements = _amountGlobal.reduce(
                    (total, _find) => {
                        if (_find.id_pay_method === 31) {
                            return total;
                        }

                        return total + Number(_find.amount ?? 0);
                    },
                    0
                );
            }

            let _subtotal_ = parseFloat(
                _totalGlobalMovements.toFixed(decimals)
            );










            // let _totalGlobalMovements =
            //     _amountGlobal.reduce(
            //         (total, _find) => {

            //             if (_find.id_pay_method === 31) {
            //                 return total;
            //             }
            //             return total + _find.amount;
            //         },
            //         0
            //     );


            // let _subtotal_ = _totalGlobalMovements;
            // _subtotal_ = parseFloat(_subtotal_.toFixed(decimals));

            console.log("🚀 ARRAY FINAL:", _arrayNew);
            console.log("🚀 MÉTODOS DE PAGO:", _amountGlobal);



            const totalBonificacionCC = _arrayNew.reduce(
                (total, item) => {

                    if (
                        !item.isBonificacionCC ||
                        item.status !== "Vigente"
                    ) {
                        return total;
                    }

                    return total + Number(
                        item.bonificacion ?? 0
                    );
                },
                0
            );


            console.log(
                "🚀 TOTAL BONIFICACIÓN CC VIGENTE:",
                totalBonificacionCC
            );


            setDataReport(_arrayNew);
            setDataPaymets(_amountGlobal);
            setDataCancell(_totalCancell);
            setDataMDiscount(_totalDiscount);
            setDataDiscount(_listTmp.total_discount);
            setDataPatient(_listTmp.total_patien);
            setTotal_devolution(_listTmp.total_devolution);
            setTotalPaymets(_subtotal_);
            setDataBonificacionCC(totalBonificacionCC);
        }
    };


    // * -------------
    const getTotalMovementsLabcen = (amountGlobal) => {
        return amountGlobal.reduce((total, item) => {
            // Excluir crédito y bonificación del total
            if (
                item.id_pay_method === 10 ||
                item.id_pay_method === 31
            ) {
                return total;
            }

            return total + Number(item.amount ?? 0);
        }, 0);
    };






    const handleClean = () => {

        handleUpdateValuesCash({
            mDateRange1: "",
            mDateRange2: "",
            type_company: null,
            mSelectBranch: 1
        });
        getDetailCreditCash(false)
    }


    //* PAGINATION FINAL REPORT
    const { totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1 } = usePaginationCash(dataReport.length, numberCash);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberCash;
        let aux = numberCash * currentPage1;

        endItems = aux;

        startItems = endItems - numberCash;

        let listTmp = [];

        dataReport.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listTmp.push({
                ...data,
                visibleTable:
                    visibleTable
            });
        });

        setDataReport(listTmp);
    }, [totalPageCount1, currentPage1]);


    //*PDF FINAL REPORT 
    const printCashClosing = async () => {

        let valuesBranch = formCash.mSelectBranch
        let nameBranch = valuesBranch.label

        const modifiedDataReport = dataReport.map((_find, _key) => {
            if (_validationFinance) {
                let _b = _validationFinance ? (_key + 1) : _find.nim;
                return { ..._find, nim: _b };
            }
            return null;
        }).filter(item => item !== null);

        const recoveredBalance = dataReport.reduce((total, item) => {
            if (item?.ajuste === true) {
                return total + Number(item?.amount_is_adjust ?? 0);
            }

            return total;
        }, 0);

        const recoveredDevolution = dataReport.reduce((total, item) => {
            if (item?.amount_devolution !== 0) {
                return total + Number(item?.amount_devolution ?? 0);
            }

            return total;
        }, 0);

        let data = {
            workOrderDetailCash: _validationFinance ? modifiedDataReport : dataReport,
            listMovements: dataPaymets,
            total_devolution: dataCancell,
            total_discount: dataDiscount,
            total_patien: dataReport.length ?? 0,
            name_branch: nameBranch,
            date_cash: mDateRange1,
            amount_global: totalPaymets,
            amount_discount: dataMDiscount.toFixed(2),
            recovered_balance: recoveredBalance,
            recoveredDevolution: recoveredDevolution

        };

        data.workOrderDetailCash = data.workOrderDetailCash.map(item => ({
            ...item,
            amount_is_adjust: _type_client === "https://labcen.helen-sw.com" && item.ajuste === true ? Number(item.amount_is_adjust ?? 0) : 0
        }));

        data.workOrderDetailCash.forEach(workOrderCash => {

            workOrderCash.status = workOrderCash.status === "Cancelado" ? 0 : 1;

            workOrderCash.is_fullPaid = workOrderCash.is_fullPaid !== "PENDIENTE";
        });


        let raw = JSON.stringify(data);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/CashFlow/PrintCashClosing", {
            method: 'POST',
            body: raw,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {

                if (response.status !== 200) {
                    showToastAlert("warning", "Reporte", "No se descargo el PDF.");

                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Corte de Caja.pdf")
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }


    // * REPORT GLOBAL ALL EXAMS   
    function exportToExcel(nimDataExcel) {

        console.log("🚀 ~ exportToExcel:", nimDataExcel);

        let _Report = [];
        let _array = nimDataExcel ?? [];

        const isCedimi = _type_client === "https://cedimi.helen-sw.com";

        let totalAmount = 0;
        let totalCash = 0;
        let totalCredit = 0;
        let totalCreditCard = 0;
        let totalDebitCard = 0;
        let totalTransfer = 0;
        let totalDiscount = 0;
        let totalCanceled = 0;
        let totalRecovered = 0;
        let totalDevolution = 0;

        _array.forEach((_find) => {

            const isCanceled =
                String(_find?.status ?? "").toLowerCase() === "cancelado";

            const amount =
                Number(_find?.amount ?? 0) -
                Number(_find?.bonificacion ?? 0);

            const amountAdjust =
                Number(_find?.amount_is_adjust ?? 0);

            totalDevolution += Number(_find?.amount_devolution ?? 0);

            if (!isCanceled) {

                totalAmount += amount;

                totalCash += Number(_find?.cash ?? 0);
                totalCredit += Number(_find?.credit ?? 0);
                totalCreditCard += Number(_find?.creditCard ?? 0);
                totalDebitCard += Number(_find?.debitCard ?? 0);
                totalTransfer += Number(_find?.electronicTransfer ?? 0);

                totalRecovered += amountAdjust;

            } else {

                totalCanceled += amount;
            }

            const estudios =
                Array.isArray(_find?.priceDetails) &&
                    _find.priceDetails.length > 0
                    ? _find.priceDetails
                    : [{ name: "Sin estudio" }];

            let patientName = _find?.namePatiente ?? "";

            if (_find?.flow_b === true) {
                patientName = patientName
                    .split(" ")
                    .slice(0, 2)
                    .join(" ");
            }

            estudios.forEach((estudio, idx) => {

                const isFirst = idx === 0;

                if (!isCanceled) {
                    totalDiscount += Number(estudio?.total_discount ?? 0);
                }

                const reportObject = {

                    _isFlowB: _find?.flow_b === true,

                    "Solicitud(NIM)": isFirst ? _find?.nim : "",
                    ...(!isCedimi && isFirst
                        ? {
                            "Tipo": _find?.is_micro
                                ? "Microsanitaria"
                                : "Clínico"
                        }
                        : {}),
                    "Fecha": isFirst ? _find?.fech_admision : "",
                    "Hora": isFirst ? _find?.hour : "",
                    "Sucursal": isFirst ? _find?.name_branches : "",
                    "Razón Social de la factura": isFirst ? _find?.name_receptor : "",
                    "RFC": isFirst ? _find?.rfc_receptor : "",
                    "Serie-Folio": isFirst ? _find?.folio_invoice : "",
                    "Fecha y Hora de emisión": isFirst ? _find?.emission_date_invoice : "",
                    "Efectivo": isFirst ? Number(_find?.cash ?? 0) : "",
                    "Credito": isFirst ? Number(_find?.credit ?? 0) : "",
                    "Tarjeta de Crédito": isFirst ? Number(_find?.creditCard ?? 0) : "",
                    "Tarjeta de Debito": isFirst ? Number(_find?.debitCard ?? 0) : "",
                    "Transferencia": isFirst ? Number(_find?.electronicTransfer ?? 0) : "",
                    ...(!_validationFinance
                        ? {
                            "Bonificación": isFirst
                                ? Number(_find?.bonificacion ?? 0)
                                : ""
                        }
                        : {}),
                    ...(isCedimi && _validationFinance
                        ? {
                            "Control de calidad": isFirst
                                ? Number(_find?.bonificacion ?? 0)
                                : ""
                        }
                        : {}),
                    "Total orden": isFirst ? amount : "",
                    "Pendiente a Facturar": isFirst ? _find?.required_invoice : "",
                    "Facturado": isFirst
                        ? (
                            _validationFinance && _find?.flow_b === true
                                ? "No"
                                : (
                                    _find?.is_invoice === "Pendiente"
                                        ? "No"
                                        : "Si"
                                )
                        )
                        : "",

                    ...(_validationFinance && isFirst
                        ? {
                            "Cancelación CC": _find?.flow_b
                                ? "Si"
                                : "No"
                        }
                        : {}),

                    ...(_validationFinance
                        ? {
                            "Observación de control de calidad":
                                _find?.qc_reason ?? "N/A"
                        }
                        : {}),

                    ...(!_validationFinance
                        ? {
                            "Tipo de descuento": isFirst
                                ? (
                                    _find?.name_Preloaded_discount ||
                                    _find?.nameCommont ||
                                    "N/A"
                                )
                                : ""
                        }
                        : {}),

                    "Edad": isFirst
                        ? (
                            _find?.age
                                ? `${_find.age} años`
                                : "Edad no disponible"
                        )
                        : "",

                    ...(!_validationFinance
                        ? {
                            "Porcentaje de descuento": isFirst
                                ? (
                                    (
                                        _find?.nameCommont === "Descuento Especial"
                                            ? _find?.amountPercentag1
                                            : _find?.amountPercentag
                                    ) != null
                                        ? `${(
                                            _find?.nameCommont === "Descuento Especial"
                                                ? _find?.amountPercentag1
                                                : _find?.amountPercentag
                                        )}%`
                                        : "N/A"
                                )
                                : ""
                        }
                        : {}),

                    "Usuario que realizo admisión": isFirst ? (_find?.user ?? "") : "",
                    "Usuario que realizo recuperación": isFirst ? (_find?.nameUserAdjust ?? "") : "",
                    "Estatus": (
                        _validationFinance && _find?.flow_b === true
                    )
                        ? ""
                        : (_find?.status ?? ""),

                    "Nombre": isFirst
                        ? (
                            _find?.is_micro
                                ? (
                                    _find?.type === "Empresas"
                                        ? _find?.name_company
                                        : patientName
                                )
                                : patientName
                        )
                        : "",
                    "Médico": _find?.doctorName || "",
                    ...(isCedimi && isFirst
                        ? {
                            "No. Colegiado": _find?.doctorCode
                        }
                        : {}),
                    "Compañia": isFirst ? (_find?.type || "Público General") : "",
                    ...(
                        isFirst &&
                            _type_client === "https://pyrsa.helen-sw.com"
                            ? {
                                "Convenio": (
                                    _find?.type === "Empresas"
                                        ? _find?.name_agreenent
                                        : "N/A"
                                )
                            }
                            : {}
                    ),

                    "Nombre de la empresa": isFirst
                        ? (
                            _find?.type === "Empresas"
                                ? _find?.name_company
                                : "N/A"
                        )
                        : "",
                    ...(isCedimi && isFirst
                        ? {
                            "Vendedor": _find?.seller
                        }
                        : {}),
                    "Estudio": estudio?.name || "Sin estudio",
                    "Subtotal": Number(estudio?.price ?? 0),
                    "IVA": Number(estudio?.price_tax ?? 0),
                    "Descuento": (_valid_Finance && _find?.flow_b === true) ? 0 : Number(estudio?.total_discount ?? 0),
                    "Urgencia": Number(estudio?.price_urgent ?? 0),
                    "Total": Number(estudio?.total ?? 0),
                    "Estatus del estudio": (
                        _valid_Finance && _find?.flow_b === true
                    )
                        ? ""
                        : (estudio?.status_exam || "N/A"),

                    ...(isCedimi && isFirst
                        ? {
                            "No. Colegiado": _find?.doctorCode
                        }
                        : {}),

                    ...(
                        isFirst &&
                            _type_client === "https://labcen.helen-sw.com"
                            ? {
                                "Estado de pago": _find?.is_fullPaid ?? ""
                            }
                            : {}
                    )
                };

                _Report.push(reportObject);
            });
        });

        const exportReport = _Report.map(item => {
            const { _isFlowB, ...rest } = item;
            return rest;
        });

        const branchName =
            _array.length > 0
                ? (
                    _array.every(item =>
                        item?.name_branches === _array[0]?.name_branches
                    )
                        ? (_array[0]?.name_branches ?? "Todas las sucursales")
                        : "Varias sucursales"
                )
                : "Todas las sucursales";

        // ============================================
        // 3. COLORES Y FORMATOS
        // ============================================
        const navy = "1B4F72";
        const blue = "1B658B";
        const lightBlue = "EFF7FD";
        const lightGray = "F1F5F8";
        const white = "FFFFFF";
        const green = "166534";
        const borderColor = "D9E2F3";

        const moneyFormat = '$#,##0.00;[Red]-$#,##0.00';

        const workbook = XLSX.utils.book_new();


        if (isCedimi) {

            const worksheet = XLSX.utils.json_to_sheet(exportReport);

            const range = worksheet["!ref"]
                ? XLSX.utils.decode_range(worksheet["!ref"])
                : null;

            if (range) {

                for (
                    let col = range.s.c;
                    col <= range.e.c;
                    col++
                ) {

                    const address = XLSX.utils.encode_cell({
                        r: 0,
                        c: col
                    });

                    if (worksheet[address]) {
                        worksheet[address].s = {
                            fill: {
                                patternType: "solid",
                                fgColor: { rgb: blue }
                            },
                            font: {
                                bold: true,
                                color: { rgb: white }
                            },
                            alignment: {
                                horizontal: "center",
                                vertical: "center",
                                wrapText: true
                            },
                            border: {
                                top: {
                                    style: "thin",
                                    color: { rgb: "D9E2F3" }
                                },
                                bottom: {
                                    style: "thin",
                                    color: { rgb: "D9E2F3" }
                                },
                                left: {
                                    style: "thin",
                                    color: { rgb: "D9E2F3" }
                                },
                                right: {
                                    style: "thin",
                                    color: { rgb: "D9E2F3" }
                                }
                            }
                        };
                    }
                }

                // Conservar el resaltado original de Flow B.
                _Report.forEach((reportItem, index) => {

                    if (_validationFinance && reportItem?._isFlowB) {

                        const excelRow = index + 1;

                        for (
                            let col = range.s.c;
                            col <= range.e.c;
                            col++
                        ) {

                            const address = XLSX.utils.encode_cell({
                                r: excelRow,
                                c: col
                            });

                            if (!worksheet[address]) {
                                worksheet[address] = {
                                    t: "s",
                                    v: ""
                                };
                            }

                            worksheet[address].s = {
                                fill: {
                                    patternType: "solid",
                                    fgColor: { rgb: "D9EAF7" }
                                },
                                font: {
                                    color: { rgb: "1B4F72" }
                                },
                                border: {
                                    top: {
                                        style: "thin",
                                        color: { rgb: "B8CCE4" }
                                    },
                                    bottom: {
                                        style: "thin",
                                        color: { rgb: "B8CCE4" }
                                    },
                                    left: {
                                        style: "thin",
                                        color: { rgb: "B8CCE4" }
                                    },
                                    right: {
                                        style: "thin",
                                        color: { rgb: "B8CCE4" }
                                    }
                                }
                            };
                        }
                    }
                });
            }

            worksheet["!cols"] = exportReport.length > 0
                ? Object.keys(exportReport[0]).map(column => {

                    if (column === "Razón Social de la factura") {
                        return { wch: 28 };
                    }

                    if (column === "Fecha y Hora de emisión") {
                        return { wch: 23 };
                    }

                    if (column === "Usuario que realizo admisión") {
                        return { wch: 28 };
                    }

                    if (column === "Usuario que realizo recuperación") {
                        return { wch: 30 };
                    }

                    if (column === "Nombre de la empresa") {
                        return { wch: 28 };
                    }

                    if (column === "Nombre") {
                        return { wch: 30 };
                    }

                    if (column === "Estudio") {
                        return { wch: 35 };
                    }

                    if (column === "Médico") {
                        return { wch: 28 };
                    }

                    return { wch: 18 };
                })
                : [];

            XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

        } else {


            const worksheet = XLSX.utils.aoa_to_sheet([

                ["REPORTE GLOBAL"],

                ["Reporte detallado de ingresos, estudios y movimientos"],

                [
                    `SUCURSAL: ${branchName}`,
                    "", "", "", "",
                    "", "", "", "", ""
                ],

                [],

                [
                    "TOTAL GLOBAL", "",
                    "MOVIMIENTOS", "",
                    "MONTO DE DEVOLUCIÓN", "",
                    "CANCELACIONES", "",
                    "SALDO RECUPERADO", ""
                ],

                [
                    totalAmount, "",
                    _array.length, "",
                    totalDevolution, "",
                    totalCanceled, "",
                    totalRecovered, ""
                ],

                [],

                [
                    "EFECTIVO", "",
                    "TARJETA DE CRÉDITO", "",
                    "TARJETA DE DÉBITO", "",
                    "CRÉDITO", "",
                    "TRANSFERENCIA", ""
                ],

                [
                    totalCash, "",
                    totalCreditCard, "",
                    totalDebitCard, "",
                    totalCredit, "",
                    totalTransfer, ""
                ],

                [],

                ["DETALLE DE MOVIMIENTOS"]
            ]);


            worksheet["!merges"] = [

                { s: { r: 0, c: 0 }, e: { r: 0, c: 9 } },
                { s: { r: 1, c: 0 }, e: { r: 1, c: 9 } },

                { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
                { s: { r: 2, c: 5 }, e: { r: 2, c: 9 } },

                // Indicadores.
                { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } },
                { s: { r: 4, c: 2 }, e: { r: 4, c: 3 } },
                { s: { r: 4, c: 4 }, e: { r: 4, c: 5 } },
                { s: { r: 4, c: 6 }, e: { r: 4, c: 7 } },
                { s: { r: 4, c: 8 }, e: { r: 4, c: 9 } },

                { s: { r: 5, c: 0 }, e: { r: 5, c: 1 } },
                { s: { r: 5, c: 2 }, e: { r: 5, c: 3 } },
                { s: { r: 5, c: 4 }, e: { r: 5, c: 5 } },
                { s: { r: 5, c: 6 }, e: { r: 5, c: 7 } },
                { s: { r: 5, c: 8 }, e: { r: 5, c: 9 } },

                // Métodos de pago.
                { s: { r: 7, c: 0 }, e: { r: 7, c: 1 } },
                { s: { r: 7, c: 2 }, e: { r: 7, c: 3 } },
                { s: { r: 7, c: 4 }, e: { r: 7, c: 5 } },
                { s: { r: 7, c: 6 }, e: { r: 7, c: 7 } },
                { s: { r: 7, c: 8 }, e: { r: 7, c: 9 } },

                { s: { r: 8, c: 0 }, e: { r: 8, c: 1 } },
                { s: { r: 8, c: 2 }, e: { r: 8, c: 3 } },
                { s: { r: 8, c: 4 }, e: { r: 8, c: 5 } },
                { s: { r: 8, c: 6 }, e: { r: 8, c: 7 } },
                { s: { r: 8, c: 8 }, e: { r: 8, c: 9 } },

                // Título del detalle.
                { s: { r: 10, c: 0 }, e: { r: 10, c: 28 } }
            ];

            XLSX.utils.sheet_add_json(
                worksheet,
                exportReport,
                {
                    origin: "A12"
                }
            );


            const setCellStyle = (address, style) => {

                if (!worksheet[address]) {
                    worksheet[address] = {
                        t: "s",
                        v: ""
                    };
                }

                worksheet[address].s = style;
            };

            // Título principal.
            setCellStyle("A1", {
                font: {
                    bold: true,
                    sz: 20,
                    color: { rgb: navy }
                },
                alignment: {
                    vertical: "center"
                }
            });

            // Subtítulo.
            setCellStyle("A2", {
                font: {
                    sz: 10,
                    color: { rgb: "64748B" }
                },
                alignment: {
                    vertical: "center"
                }
            });

            // Sucursal.
            setCellStyle("A3", {
                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: navy }
                },
                alignment: {
                    vertical: "center"
                }
            });


            const cards = [
                {
                    label: "A5",
                    value: "A6",
                    dark: true,
                    format: moneyFormat
                },
                {
                    label: "C5",
                    value: "C6",
                    dark: false,
                    format: "0"
                },
                {
                    label: "E5",
                    value: "E6",
                    dark: false,
                    format: moneyFormat
                },
                {
                    label: "G5",
                    value: "G6",
                    dark: false,
                    format: moneyFormat
                },
                {
                    label: "I5",
                    value: "I6",
                    dark: false,
                    format: moneyFormat
                }
            ];

            cards.forEach(card => {

                const background = card.dark ? navy : lightGray;
                const foreground = card.dark ? white : navy;

                const baseStyle = {
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: background }
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "left"
                    }
                };

                setCellStyle(card.label, {
                    ...baseStyle,
                    font: {
                        bold: true,
                        sz: 9,
                        color: { rgb: foreground }
                    }
                });

                setCellStyle(card.value, {
                    ...baseStyle,
                    font: {
                        bold: true,
                        sz: 16,
                        color: { rgb: foreground }
                    },
                    numFmt: card.format
                });
            });


            const paymentCells = [
                { label: "A8", value: "A9" },
                { label: "C8", value: "C9" },
                { label: "E8", value: "E9" },
                { label: "G8", value: "G9" },
                { label: "I8", value: "I9" }
            ];

            paymentCells.forEach(item => {

                setCellStyle(item.label, {
                    font: {
                        bold: true,
                        sz: 9,
                        color: { rgb: navy }
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        bottom: {
                            style: "thin",
                            color: { rgb: borderColor }
                        }
                    }
                });

                setCellStyle(item.value, {
                    font: {
                        bold: true,
                        sz: 11,
                        color: { rgb: green }
                    },
                    numFmt: moneyFormat,
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        bottom: {
                            style: "thin",
                            color: { rgb: borderColor }
                        }
                    }
                });
            });


            const detailHeaderRow = 11;

            if (worksheet["!ref"]) {

                const detailRange =
                    XLSX.utils.decode_range(worksheet["!ref"]);

                const detailColumnCount =
                    exportReport.length > 0
                        ? Object.keys(exportReport[0]).length
                        : 0;

                for (
                    let col = 0;
                    col < detailColumnCount;
                    col++
                ) {

                    const address = XLSX.utils.encode_cell({
                        r: detailHeaderRow,
                        c: col
                    });

                    setCellStyle(address, {
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: blue }
                        },
                        font: {
                            bold: true,
                            color: { rgb: white },
                            sz: 9
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center",
                            wrapText: true
                        },
                        border: {
                            bottom: {
                                style: "thin",
                                color: { rgb: borderColor }
                            }
                        }
                    });
                }


                _Report.forEach((reportItem, index) => {

                    if (
                        _validationFinance &&
                        reportItem?._isFlowB
                    ) {

                        const excelRow = index + 12;

                        for (
                            let col = 0;
                            col < detailColumnCount;
                            col++
                        ) {

                            const address = XLSX.utils.encode_cell({
                                r: excelRow,
                                c: col
                            });

                            const cell = worksheet[address];

                            if (cell) {
                                cell.s = {
                                    ...(cell.s || {}),
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9EAF7" }
                                    }
                                };
                            }
                        }
                    }
                });
            }


            const totalRow = {};

            Object.keys(exportReport[0] ?? {}).forEach(column => {
                totalRow[column] = "";
            });

            totalRow["Efectivo"] = totalCash;
            totalRow["Credito"] = totalCredit;
            totalRow["Tarjeta de Crédito"] = totalCreditCard;
            totalRow["Tarjeta de Debito"] = totalDebitCard;
            totalRow["Transferencia"] = totalTransfer;
            totalRow["Total orden"] = totalAmount;
            totalRow["Descuento"] = totalDiscount;

            if ("Total S.R" in totalRow) {
                totalRow["Total S.R"] = totalRecovered;
            }

            XLSX.utils.sheet_add_json(
                worksheet,
                [totalRow],
                {
                    skipHeader: true,
                    origin: -1
                }
            );

            const finalRange =
                XLSX.utils.decode_range(worksheet["!ref"]);

            const totalExcelRow = finalRange.e.r;

            const totalColumnCount =
                Object.keys(exportReport[0] ?? {}).length;

            for (
                let col = 0;
                col < totalColumnCount;
                col++
            ) {

                const address = XLSX.utils.encode_cell({
                    r: totalExcelRow,
                    c: col
                });

                setCellStyle(address, {
                    font: {
                        bold: true,
                        color: { rgb: navy }
                    },
                    border: {
                        top: {
                            style: "medium",
                            color: { rgb: blue }
                        }
                    }
                });
            }


            const headerMap = {};

            Object.keys(exportReport[0] ?? {}).forEach((column, index) => {
                headerMap[column] = index;
            });

            const moneyColumnNames = [
                "Efectivo",
                "Credito",
                "Tarjeta de Crédito",
                "Tarjeta de Debito",
                "Transferencia",
                "Bonificación",
                "Control de calidad",
                "Total orden",
                "Subtotal",
                "IVA",
                "Descuento",
                "Urgencia",
                "Total"
            ];

            moneyColumnNames.forEach(column => {

                const col = headerMap[column];

                if (col === undefined) {
                    return;
                }

                for (
                    let row = 12;
                    row <= totalExcelRow;
                    row++
                ) {

                    const address = XLSX.utils.encode_cell({
                        r: row - 1,
                        c: col
                    });

                    if (
                        worksheet[address] &&
                        typeof worksheet[address].v === "number"
                    ) {
                        worksheet[address].s = {
                            ...(worksheet[address].s || {}),
                            numFmt: moneyFormat
                        };
                    }
                }
            });


            worksheet["!cols"] = Object.keys(exportReport[0] ?? {})
                .map(column => {

                    if (column === "Razón Social de la factura") {
                        return { wch: 28 };
                    }

                    if (column === "Fecha y Hora de emisión") {
                        return { wch: 23 };
                    }

                    if (column === "Usuario que realizo admisión") {
                        return { wch: 28 };
                    }

                    if (column === "Usuario que realizo recuperación") {
                        return { wch: 30 };
                    }

                    if (column === "Nombre de la empresa") {
                        return { wch: 28 };
                    }

                    if (column === "Nombre") {
                        return { wch: 30 };
                    }

                    if (column === "Estudio") {
                        return { wch: 35 };
                    }

                    if (column === "Médico") {
                        return { wch: 28 };
                    }

                    return { wch: 18 };
                });


            worksheet["!rows"] = [
                { hpt: 30 },
                { hpt: 18 },
                { hpt: 20 },
                { hpt: 8 },
                { hpt: 22 },
                { hpt: 32 },
                { hpt: 8 },
                { hpt: 20 },
                { hpt: 24 },
                { hpt: 8 },
                { hpt: 25 },
                { hpt: 32 }
            ];

            setCellStyle("A11", {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: navy }
                },
                font: {
                    bold: true,
                    sz: 12,
                    color: { rgb: white }
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center"
                }
            });

            // Congelar encabezados del detalle.
            worksheet["!freeze"] = {
                xSplit: 0,
                ySplit: 12,
                topLeftCell: "A13",
                activePane: "bottomLeft",
                state: "frozen"
            };

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Reporte Global"
            );
        }


        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: "xlsx",
                type: "array"
            }
        );

        const dataBlob = new Blob(
            [excelBuffer],
            {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );

        const fileName = "Reporte Global con estudios.xlsx";

        if (
            typeof window !== "undefined" &&
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) {

            window.navigator.msSaveOrOpenBlob(
                dataBlob,
                fileName
            );

        } else {

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }
    }

    // * REPORT GLOBAL WITHOUT EXAMS   
    function exportToExcelWithoutExams(nimDataExcel) {

        let _Report = [];
        let _array = nimDataExcel ?? [];

        let totalAmount = 0;
        let totalCash = 0;
        let totalCredit = 0;
        let totalCreditCard = 0;
        let totalDebitCard = 0;
        let totalTransfer = 0;
        let totalDiscount = 0;
        let totalCanceled = 0;
        let totalRecovered = 0;
        let totalDevolution = 0;

        const isCedimi =
            _type_client === "https://cedimi.helen-sw.com";



        _array.forEach((_find) => {

            const isCanceled =
                String(_find?.status ?? "").toLowerCase() === "cancelado";

            const amount = Number(_find?.amount ?? 0);
            const amountAdjust = Number(_find?.amount_is_adjust ?? 0);
            const amountDiscount = Number(_find?.bonificacion ?? 0);
            totalDevolution += Number(_find?.amount_devolution ?? 0);

            const _a = "Solicitud(NIM)";

            if (!isCanceled) {

                totalAmount += amount;

                totalCash += Number(_find?.cash ?? 0);
                totalCredit += Number(_find?.credit ?? 0);
                totalCreditCard += Number(_find?.creditCard ?? 0);
                totalDebitCard += Number(_find?.debitCard ?? 0);
                totalTransfer += Number(_find?.electronicTransfer ?? 0);

                if (!_validationFinance) {
                    totalDiscount += amountDiscount;
                }

                totalRecovered += amountAdjust;

            } else {

                totalCanceled += amount;
            }


            const reportObject = {

                _isFlowB: _find?.flow_b === true,

                [_a]: _find?.nim,

                ...(!isCedimi
                    ? {
                        "Tipo": _find?.is_micro
                            ? "Microsanitaria"
                            : "Clínico"
                    }
                    : {}),

                "Fecha": _find?.fech_admision,
                "Hora": _find?.hour,
                "Sucursal": _find?.name_branches,
                "Razón Social de la factura": _find?.name_receptor,
                "RFC": _find?.rfc_receptor,
                "Serie-Folio": _find?.folio_invoice,
                "Fecha y Hora de emisión": _find?.emission_date_invoice,

                "Efectivo": Number(_find?.cash ?? 0),
                "Credito": Number(_find?.credit ?? 0),
                "Tarjeta de Crédito": Number(_find?.creditCard ?? 0),
                "Tarjeta de Debito": Number(_find?.debitCard ?? 0),
                "Transferencia": Number(_find?.electronicTransfer ?? 0),
                ...(!_validationFinance
                    ? {
                        "Bonificación": Number(_find?.bonificacion ?? 0)
                    }
                    : {}),

                ...(isCedimi && _validationFinance
                    ? {
                        "Control de calidad": Number(_find?.bonificacion ?? 0)
                    }
                    : {}),
                "Total": isCanceled ? 0 : amount,
                "Pendiente a Facturar": _find?.required_invoice,
                "Facturado":
                    (_validationFinance && _find?.flow_b === true)
                        ? "No"
                        : (_find?.is_invoice === "Pendiente" ? "No" : "Si"),
                ...(_validationFinance
                    ? {
                        "Cancelación CC": _find?.flow_b ? "Si" : "No",
                        "Observación de control de calidad":
                            _find?.qc_reason ?? "N/A"
                    }
                    : {}),
                ...(!_validationFinance
                    ? {
                        "Tipo de descuento":
                            _find?.name_Preloaded_discount !== ""
                                ? _find?.name_Preloaded_discount
                                : _find?.nameCommont !== ""
                                    ? _find?.nameCommont
                                    : "N/A"
                    }
                    : {}),

                "Edad": _find?.age
                    ? `${_find.age} años`
                    : "Edad no disponible",

                ...(!_validationFinance
                    ? {
                        "Porcentaje de descuento":
                            _find?.name_Preloaded_discount !== ""
                                ? _find?.percentagePreloaded_discount
                                : _find?.nameCommont !== ""
                                    ? _find?.amountPercentag
                                    : "N/A"
                    }
                    : {}),
                "Usuario que realizo admisión": _find?.user,
                "Usuario que realizo recuperación": _find?.nameUserAdjust,
                "Estatus":
                    (_validationFinance && _find?.flow_b === true)
                        ? ""
                        : _find?.status,

                "Nombre": _find?.is_micro
                    ? (_find?.type === "Empresas"
                        ? _find?.name_company
                        : _find?.namePatiente)
                    : _find?.namePatiente,

                ...(isCedimi
                    ? {
                        "Médico": _find?.doctorName,
                        "No. Colegiado": _find?.doctorCode
                    }
                    : {}),
                "Compañia": _find?.type,
                "Nombre de la empresa":
                    _find?.type === "Empresas"
                        ? _find?.name_company
                        : "N/A",
                ...(_type_client === "https://pyrsa.helen-sw.com"
                    ? {
                        "Convenio":
                            _find?.type === "Empresas"
                                ? _find?.name_agreenent
                                : "N/A"
                    }
                    : {}),
                ...(isCedimi
                    ? {
                        "Vendedor": _find?.seller
                    }
                    : {}),

                ...(_type_client === "https://labcen.helen-sw.com"
                    ? {
                        "Estado de pago": _find?.is_fullPaid
                    }
                    : {})
            };

            _Report.push(reportObject);
        });

        const exportReport = _Report.map(item => {

            const { _isFlowB, ...rest } = item;

            return rest;
        });

        const branchName = _array?.[0]?.name_branches ?? "Todas las sucursales";

        let worksheet;

        if (isCedimi) {

            worksheet = XLSX.utils.json_to_sheet(exportReport);

            const range = worksheet["!ref"]
                ? XLSX.utils.decode_range(worksheet["!ref"])
                : { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };


            for (
                let col = range.s.c;
                col <= range.e.c;
                col++
            ) {

                const address = XLSX.utils.encode_cell({
                    r: 0,
                    c: col
                });

                const cell = worksheet[address];

                if (cell) {

                    cell.s = {

                        fill: {
                            patternType: "solid",
                            fgColor: {
                                rgb: "1B658B"
                            }
                        },

                        font: {
                            bold: true,
                            color: {
                                rgb: "FFFFFF"
                            }
                        },

                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },

                        border: {

                            top: {
                                style: "thin",
                                color: {
                                    rgb: "D9E2F3"
                                }
                            },

                            bottom: {
                                style: "thin",
                                color: {
                                    rgb: "D9E2F3"
                                }
                            },

                            left: {
                                style: "thin",
                                color: {
                                    rgb: "D9E2F3"
                                }
                            },

                            right: {
                                style: "thin",
                                color: {
                                    rgb: "D9E2F3"
                                }
                            }
                        }
                    };
                }
            }


            _Report.forEach((reportItem, index) => {

                if (
                    _validationFinance &&
                    reportItem?._isFlowB
                ) {

                    const excelRow = index + 1;

                    for (
                        let col = range.s.c;
                        col <= range.e.c;
                        col++
                    ) {

                        const address = XLSX.utils.encode_cell({
                            r: excelRow,
                            c: col
                        });

                        if (!worksheet[address]) {
                            worksheet[address] = {
                                t: "s",
                                v: ""
                            };
                        }

                        worksheet[address].s = {

                            fill: {
                                patternType: "solid",
                                fgColor: {
                                    rgb: "D9EAF7"
                                }
                            },

                            font: {
                                color: {
                                    rgb: "1B4F72"
                                }
                            },

                            border: {

                                top: {
                                    style: "thin",
                                    color: {
                                        rgb: "B8CCE4"
                                    }
                                },

                                bottom: {
                                    style: "thin",
                                    color: {
                                        rgb: "B8CCE4"
                                    }
                                },

                                left: {
                                    style: "thin",
                                    color: {
                                        rgb: "B8CCE4"
                                    }
                                },

                                right: {
                                    style: "thin",
                                    color: {
                                        rgb: "B8CCE4"
                                    }
                                }
                            }
                        };
                    }
                }
            });


            const totalRow = {
                "Solicitud(NIM)": "",
                ...(!isCedimi ? { "Tipo": "" } : {}),
                "Fecha": "",
                "Hora": "",
                "Sucursal": "",
                "Razón Social de la factura": "",
                "RFC": "",
                "Serie-Folio": "",
                "Fecha y Hora de emisión": "",
                "Efectivo": totalCash,
                "Credito": totalCredit,
                "Tarjeta de Crédito": totalCreditCard,
                "Tarjeta de Debito": totalDebitCard,
                "Transferencia": totalTransfer,
                ...(!_validationFinance
                    ? {
                        "Bonificación": totalDiscount
                    }
                    : {}),
                ...(isCedimi && _validationFinance
                    ? {
                        "Control de calidad": ""
                    }
                    : {}),

                "Total": totalAmount,
                "Pendiente a Facturar": "",
                "Facturado": "",

                ...(_validationFinance
                    ? {
                        "Cancelación CC": "",
                        "Observación de control de calidad": ""
                    }
                    : {}),

                ...(!_validationFinance
                    ? {
                        "Tipo de descuento": ""
                    }
                    : {}),

                "Edad": "",
                ...(!_validationFinance
                    ? {
                        "Porcentaje de descuento": ""
                    }
                    : {}),
                "Usuario que realizo admisión": "",
                "Usuario que realizo recuperación": "",
                "Estatus": "",
                "Nombre": "",
                ...(isCedimi
                    ? {
                        "Médico": "",
                        "No. Colegiado": ""
                    }
                    : {}),
                "Compañia": "",
                "Nombre de la empresa": "",
                ...(_type_client === "https://pyrsa.helen-sw.com"
                    ? {
                        "Convenio": ""
                    }
                    : {}),

                ...(isCedimi
                    ? {
                        "Vendedor": ""
                    }
                    : {}),

                ...(_type_client === "https://labcen.helen-sw.com"
                    ? {
                        "Estado de pago": ""
                    }
                    : {})
            };

            XLSX.utils.sheet_add_json(
                worksheet,
                [totalRow],
                {
                    skipHeader: true,
                    origin: -1
                }
            );


            const finalRange = XLSX.utils.decode_range(
                worksheet["!ref"]
            );

            const totalExcelRow = finalRange.e.r;

            for (
                let col = finalRange.s.c;
                col <= finalRange.e.c;
                col++
            ) {

                const address = XLSX.utils.encode_cell({
                    r: totalExcelRow,
                    c: col
                });

                if (!worksheet[address]) {
                    worksheet[address] = {
                        t: "s",
                        v: ""
                    };
                }

                worksheet[address].s = {

                    font: {
                        bold: true,
                        color: {
                            rgb: "1B4F72"
                        }
                    },

                    border: {
                        top: {
                            style: "medium",
                            color: {
                                rgb: "1B658B"
                            }
                        }
                    }
                };
            }


            if (exportReport.length > 0) {

                worksheet["!cols"] = Object.keys(
                    exportReport[0]
                ).map(column => {

                    if (column === "Razón Social de la factura") {
                        return { wch: 28 };
                    }

                    if (column === "Fecha y Hora de emisión") {
                        return { wch: 23 };
                    }

                    if (column === "Usuario que realizo admisión") {
                        return { wch: 28 };
                    }

                    if (column === "Usuario que realizo recuperación") {
                        return { wch: 30 };
                    }

                    if (column === "Nombre") {
                        return { wch: 30 };
                    }

                    if (column === "Nombre de la empresa") {
                        return { wch: 28 };
                    }

                    if (column === "Médico") {
                        return { wch: 28 };
                    }

                    return { wch: 18 };
                });
            }

        } else {



            const navy = "1B4F72";
            const blue = "1B658B";
            const lightBlue = "EFF7FD";
            const lightGray = "F1F5F8";
            const white = "FFFFFF";
            const green = "166534";
            const borderColor = "D9E2F3";

            const moneyFormat =
                '$#,##0.00;[Red]-$#,##0.00';


            const totalMovements = _array.filter(item =>
                String(item?.status ?? "").toLowerCase() !== "cancelado"
            ).length;


            worksheet = XLSX.utils.aoa_to_sheet([

                ["REPORTE GLOBAL"],

                ["Reporte detallado de ingresos y movimientos"],

                [
                    `SUCURSAL: ${branchName}`,
                    "", "", "", "",
                    `FECHA DE GENERACIÓN: ${new Date().toLocaleDateString("es-MX")}`,
                    "", "", "", ""
                ],

                [],

                [
                    "TOTAL GLOBAL", "",
                    "MOVIMIENTOS", "",
                    "MONTO DE DEVOLUCIÓN", "",
                    "CANCELACIONES", "",
                    "SALDO RECUPERADO", ""
                ],

                [
                    totalAmount, "",
                    totalMovements, "",
                    totalDevolution, "",
                    totalCanceled, "",
                    totalRecovered, ""
                ],

                [],

                [
                    "EFECTIVO", "",
                    "TARJETA DE CRÉDITO", "",
                    "TARJETA DE DÉBITO", "",
                    "CRÉDITO", "",
                    "TRANSFERENCIA", ""
                ],

                [
                    totalCash, "",
                    totalCreditCard, "",
                    totalDebitCard, "",
                    totalCredit, "",
                    totalTransfer, ""
                ],

                [],

                ["DETALLE DE MOVIMIENTOS"]
            ]);



            const detailColumnCount = Object.keys(
                exportReport[0] ?? {}
            ).length;

            const lastDetailCol = Math.max(
                9,
                detailColumnCount - 1
            );

            worksheet["!merges"] = [

                // Título y subtítulo.
                {
                    s: { r: 0, c: 0 },
                    e: { r: 0, c: 9 }
                },

                {
                    s: { r: 1, c: 0 },
                    e: { r: 1, c: 9 }
                },

                // Sucursal y fecha.
                {
                    s: { r: 2, c: 0 },
                    e: { r: 2, c: 4 }
                },

                {
                    s: { r: 2, c: 5 },
                    e: { r: 2, c: 9 }
                },

                // Indicadores superiores.
                {
                    s: { r: 4, c: 0 },
                    e: { r: 4, c: 1 }
                },

                {
                    s: { r: 4, c: 2 },
                    e: { r: 4, c: 3 }
                },

                {
                    s: { r: 4, c: 4 },
                    e: { r: 4, c: 5 }
                },

                {
                    s: { r: 4, c: 6 },
                    e: { r: 4, c: 7 }
                },

                {
                    s: { r: 4, c: 8 },
                    e: { r: 4, c: 9 }
                },

                // Valores superiores.
                {
                    s: { r: 5, c: 0 },
                    e: { r: 5, c: 1 }
                },

                {
                    s: { r: 5, c: 2 },
                    e: { r: 5, c: 3 }
                },

                {
                    s: { r: 5, c: 4 },
                    e: { r: 5, c: 5 }
                },

                {
                    s: { r: 5, c: 6 },
                    e: { r: 5, c: 7 }
                },

                {
                    s: { r: 5, c: 8 },
                    e: { r: 5, c: 9 }
                },

                // Métodos de pago.
                {
                    s: { r: 7, c: 0 },
                    e: { r: 7, c: 1 }
                },

                {
                    s: { r: 7, c: 2 },
                    e: { r: 7, c: 3 }
                },

                {
                    s: { r: 7, c: 4 },
                    e: { r: 7, c: 5 }
                },

                {
                    s: { r: 7, c: 6 },
                    e: { r: 7, c: 7 }
                },

                {
                    s: { r: 7, c: 8 },
                    e: { r: 7, c: 9 }
                },

                // Valores métodos de pago.
                {
                    s: { r: 8, c: 0 },
                    e: { r: 8, c: 1 }
                },

                {
                    s: { r: 8, c: 2 },
                    e: { r: 8, c: 3 }
                },

                {
                    s: { r: 8, c: 4 },
                    e: { r: 8, c: 5 }
                },

                {
                    s: { r: 8, c: 6 },
                    e: { r: 8, c: 7 }
                },

                {
                    s: { r: 8, c: 8 },
                    e: { r: 8, c: 9 }
                },

                // Título de detalle.
                {
                    s: { r: 10, c: 0 },
                    e: { r: 10, c: lastDetailCol }
                }
            ];


            XLSX.utils.sheet_add_json(
                worksheet,
                exportReport,
                {
                    origin: "A12"
                }
            );



            const setCellStyle = (address, style) => {

                if (!worksheet[address]) {

                    worksheet[address] = {
                        t: "s",
                        v: ""
                    };
                }

                worksheet[address].s = style;
            };


            setCellStyle("A1", {

                font: {
                    bold: true,
                    sz: 20,
                    color: { rgb: navy }
                },

                alignment: {
                    vertical: "center"
                }
            });



            setCellStyle("A2", {

                font: {
                    sz: 10,
                    color: { rgb: "64748B" }
                }
            });



            setCellStyle("A3", {

                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: navy }
                },

                alignment: {
                    vertical: "center"
                }
            });


            setCellStyle("F3", {

                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: navy }
                },

                alignment: {
                    horizontal: "right",
                    vertical: "center"
                }
            });


            const cards = [

                {
                    label: "A5",
                    value: "A6",
                    dark: true,
                    format: moneyFormat
                },

                {
                    label: "C5",
                    value: "C6",
                    dark: false,
                    format: "0"
                },

                {
                    label: "E5",
                    value: "E6",
                    dark: false,
                    format: moneyFormat
                },

                {
                    label: "G5",
                    value: "G6",
                    dark: false,
                    format: moneyFormat
                },

                {
                    label: "I5",
                    value: "I6",
                    dark: false,
                    format: moneyFormat
                }
            ];


            cards.forEach(card => {

                const background = card.dark
                    ? navy
                    : lightGray;

                const foreground = card.dark
                    ? white
                    : navy;

                const baseStyle = {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: background
                        }
                    },

                    alignment: {
                        vertical: "center",
                        horizontal: "left"
                    }
                };


                setCellStyle(card.label, {

                    ...baseStyle,

                    font: {
                        bold: true,
                        sz: 9,
                        color: {
                            rgb: foreground
                        }
                    }
                });


                setCellStyle(card.value, {

                    ...baseStyle,

                    font: {
                        bold: true,
                        sz: 16,
                        color: {
                            rgb: foreground
                        }
                    },

                    numFmt: card.format
                });
            });



            const paymentCells = [

                {
                    label: "A8",
                    value: "A9"
                },

                {
                    label: "C8",
                    value: "C9"
                },

                {
                    label: "E8",
                    value: "E9"
                },

                {
                    label: "G8",
                    value: "G9"
                },

                {
                    label: "I8",
                    value: "I9"
                }
            ];


            paymentCells.forEach(item => {

                setCellStyle(item.label, {

                    font: {
                        bold: true,
                        sz: 9,
                        color: {
                            rgb: navy
                        }
                    },

                    alignment: {
                        vertical: "center"
                    },

                    border: {
                        bottom: {
                            style: "thin",
                            color: {
                                rgb: borderColor
                            }
                        }
                    }
                });


                setCellStyle(item.value, {

                    font: {
                        bold: true,
                        sz: 11,
                        color: {
                            rgb: green
                        }
                    },

                    numFmt: moneyFormat,

                    alignment: {
                        vertical: "center"
                    },

                    border: {
                        bottom: {
                            style: "thin",
                            color: {
                                rgb: borderColor
                            }
                        }
                    }
                });
            });



            const detailHeaderRow = 11;

            const detailRange = XLSX.utils.decode_range(
                worksheet["!ref"]
            );


            for (
                let col = 0;
                col < detailColumnCount;
                col++
            ) {

                const address = XLSX.utils.encode_cell({
                    r: detailHeaderRow,
                    c: col
                });

                setCellStyle(address, {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: "DCEAF5"
                        }
                    },

                    font: {
                        bold: true,
                        color: {
                            rgb: "1B4F72"
                        },
                        sz: 10
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true
                    },

                    border: {
                        bottom: {
                            style: "medium",
                            color: {
                                rgb: blue
                            }
                        }
                    }
                });
            }




            _Report.forEach((reportItem, index) => {

                if (
                    _validationFinance &&
                    reportItem?._isFlowB
                ) {

                    const excelRow = index + 12;

                    for (
                        let col = 0;
                        col < detailColumnCount;
                        col++
                    ) {

                        const address = XLSX.utils.encode_cell({
                            r: excelRow,
                            c: col
                        });

                        const cell = worksheet[address];

                        if (cell) {

                            cell.s = {

                                ...(cell.s || {}),

                                fill: {
                                    patternType: "solid",
                                    fgColor: {
                                        rgb: lightBlue
                                    }
                                },

                                font: {
                                    ...(cell.s?.font || {}),
                                    color: {
                                        rgb: navy
                                    }
                                }
                            };
                        }
                    }
                }
            });


            const totalRow = {

                "Solicitud(NIM)": "",
                ...(!isCedimi ? { "Tipo": "" } : {}),
                "Fecha": "",
                "Hora": "",
                "Sucursal": "",
                "Razón Social de la factura": "",
                "RFC": "",
                "Serie-Folio": "",
                "Fecha y Hora de emisión": "",
                "Efectivo": totalCash,
                "Credito": totalCredit,
                "Tarjeta de Crédito": totalCreditCard,
                "Tarjeta de Debito": totalDebitCard,
                "Transferencia": totalTransfer,
                ...(!_validationFinance
                    ? {
                        "Bonificación": totalDiscount
                    }
                    : {}),

                ...(isCedimi && _validationFinance
                    ? {
                        "Control de calidad": ""
                    }
                    : {}),
                "Total": totalAmount,
                "Pendiente a Facturar": "",
                "Facturado": "",
                ...(_validationFinance
                    ? {
                        "Cancelación CC": "",
                        "Observación de control de calidad": ""
                    }
                    : {}),

                ...(!_validationFinance
                    ? {
                        "Tipo de descuento": ""
                    }
                    : {}),
                "Edad": "",
                ...(!_validationFinance
                    ? {
                        "Porcentaje de descuento": ""
                    }
                    : {}),
                "Usuario que realizo admisión": "",
                "Usuario que realizo recuperación": "",
                "Estatus": "",
                "Nombre": "",
                ...(isCedimi
                    ? {
                        "Médico": "",
                        "No. Colegiado": ""
                    }
                    : {}),
                "Compañia": "",
                "Nombre de la empresa": "",
                ...(_type_client === "https://pyrsa.helen-sw.com"
                    ? {
                        "Convenio": ""
                    }
                    : {}),

                ...(isCedimi
                    ? {
                        "Vendedor": ""
                    }
                    : {}),
                ...(_type_client === "https://labcen.helen-sw.com"
                    ? {
                        "Estado de pago": ""
                    }
                    : {})
            };


            XLSX.utils.sheet_add_json(
                worksheet,
                [totalRow],
                {
                    skipHeader: true,
                    origin: -1
                }
            );


            const finalRange = XLSX.utils.decode_range(
                worksheet["!ref"]
            );

            const totalExcelRow = finalRange.e.r;


            for (
                let col = 0;
                col < detailColumnCount;
                col++
            ) {

                const address = XLSX.utils.encode_cell({
                    r: totalExcelRow,
                    c: col
                });

                setCellStyle(address, {

                    font: {
                        bold: true,
                        color: {
                            rgb: navy
                        }
                    },

                    border: {
                        top: {
                            style: "medium",
                            color: {
                                rgb: blue
                            }
                        }
                    }
                });
            }



            worksheet["!cols"] = [

                { wch: 20 },
                { wch: 14 },
                { wch: 14 },
                { wch: 20 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 22 },
                { wch: 30 },
                { wch: 22 },
                { wch: 14 },
                { wch: 20 },
                { wch: 28 },
                { wch: 16 },
                { wch: 30 },
                { wch: 22 },
                { wch: 20 }
            ];


            // -----------------------------------------------------
            // ALTURAS
            // -----------------------------------------------------

            worksheet["!rows"] = [

                { hpt: 30 },
                { hpt: 18 },
                { hpt: 20 },
                { hpt: 8 },
                { hpt: 22 },
                { hpt: 32 },
                { hpt: 8 },
                { hpt: 20 },
                { hpt: 24 },
                { hpt: 8 },
                { hpt: 25 },
                { hpt: 32 }
            ];


            setCellStyle("A11", {

                fill: {
                    patternType: "solid",
                    fgColor: {
                        rgb: navy
                    }
                },

                font: {
                    bold: true,
                    sz: 12,
                    color: {
                        rgb: white
                    }
                },

                alignment: {
                    horizontal: "left",
                    vertical: "center"
                }
            });
        }



        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            isCedimi ? "Sheet 1" : "Reporte Global"
        );


        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: "xlsx",
                type: "array"
            }
        );


        const dataBlob = new Blob(
            [excelBuffer],
            {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );


        const fileName = "Reporte Global sin estudios.xlsx";


        if (
            typeof window !== "undefined" &&
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) {

            window.navigator.msSaveOrOpenBlob(
                dataBlob,
                fileName
            );

        } else {

            const url = window.URL.createObjectURL(
                dataBlob
            );

            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }
    }


    //*NUMBER FORMAT
    const number_format = (cantidad, decimals) => {
        cantidad += '';
        cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

        decimals = decimals || 0;

        if (isNaN(cantidad) || cantidad === 0) {
            return parseFloat(0).toFixed(decimals);
        }

        cantidad = '' + cantidad.toFixed(decimals);

        let cantidad_parts = cantidad.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(cantidad_parts[0]))
            cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

        return cantidad_parts.join('.');
    }

    //*FORMATTER
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })

    // ? CONFIGURATION DATATABLE
    const exportToExcel2 = () => {
        const ws = XLSX.utils.json_to_sheet(dataUserReport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Ventas');
        XLSX.writeFile(wb, 'Detallado de venta.xlsx');
    };


    const getBadgePatient = (label) => {
        switch (label) {
            case 'Empresas':
                return 'success';
            case 'P.General':
                return 'warning';
            default:
                return 'secondary';
        }
    };

    const getBadgeStatus = (label) => {
        switch (label) {
            case "Cancelado":
                return 'danger';

            default:
                return 'success';
        }
    };

    const customBody = (rowData) => {
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                    style={{
                        backgroundColor: "#f97316",
                        width: "110px",
                        height: "20px",
                        borderRadius: "8px",
                        color: "#fff",
                        fontSize: "10px",
                        paddingTop: "1px",
                        textAlign: "center",
                        cursor: "pointer"
                    }}
                    onClick={() => handleNim(rowData.id_work_order)}
                >
                    <i className="fa fa-angle-right f-12"></i>&nbsp;
                    <label className='f-w-600' style={{ fontSize: "10px" }}>
                        {rowData.nim ?? "------"}
                    </label>
                </div>
            </div>
        );
    };

    const handleNim = (_id_work_order) => {
        let value = "" + _id_work_order + "";
        history.push(`../../admisiones/${value}/editar`);
    };


    // * REPORT GLOBAL LABCEN 

    function exportToExcelLabcen(nimDataExcel) {

        let _Report = [];
        let _array = nimDataExcel ?? [];

        let totalAmount = 0;
        let totalCash = 0;
        let totalCredit = 0;
        let totalCreditCard = 0;
        let totalDebitCard = 0;
        let totalTransfer = 0;
        let totalDiscount = 0;
        let totalCanceled = 0;
        let totalRecovered = 0;

        _array.forEach((_find) => {

            const isCanceled =
                String(_find?.status ?? "").toLowerCase() === "cancelado";

            const amount =
                Number(_find?.amount ?? 0) -
                Number(_find?.bonificacion ?? 0);

            const amountAdjust = Number(_find?.amount_is_adjust ?? 0);

            if (!isCanceled) {
                totalAmount += amount;
                totalCash += Number(_find?.cash ?? 0);
                totalCredit += Number(_find?.credit ?? 0);
                totalCreditCard += Number(_find?.creditCard ?? 0);
                totalDebitCard += Number(_find?.debitCard ?? 0);
                totalTransfer += Number(_find?.electronicTransfer ?? 0);
                totalRecovered += amountAdjust;
            } else {
                totalCanceled += amount;
            }

            const estudios =
                Array.isArray(_find?.priceDetails) &&
                    _find.priceDetails.length > 0
                    ? _find.priceDetails
                    : [{ name: "Sin estudio" }];

            const patientName = _find?.namePatiente ?? "";

            estudios.forEach((estudio, idx) => {

                const isFirst = idx === 0;

                if (!isCanceled) {
                    totalDiscount += Number(estudio?.total_discount ?? 0);
                }

                const reportObject = {

                    _isAjuste: _find?.ajuste != null,

                    "Solicitud(NIM)": isFirst ? _find?.nim : "",
                    "Fecha": isFirst ? _find?.fech_admision : "",
                    "Hora": isFirst ? _find?.hour : "",
                    "Sucursal": isFirst ? _find?.name_branches : "",
                    "Efectivo": isFirst ? Number(_find?.cash ?? 0) : "",
                    "Credito": isFirst ? Number(_find?.credit ?? 0) : "",
                    "Tarjeta de Crédito": isFirst ? Number(_find?.creditCard ?? 0) : "",
                    "Tarjeta de Debito": isFirst ? Number(_find?.debitCard ?? 0) : "",
                    "Transferencia": isFirst ? Number(_find?.electronicTransfer ?? 0) : "",
                    "Total orden": isFirst ? amount : "",
                    "Total S.R": isFirst ? amountAdjust : "",
                    "Usuario S.R.": isFirst
                        ? (_find?.nameUserAdjust ?? "")
                        : "",
                    "Tipo de descuento": isFirst
                        ? (
                            _find?.name_Preloaded_discount ||
                            _find?.nameCommont ||
                            "N/A"
                        )
                        : "",

                    "Edad": isFirst
                        ? (_find?.age
                            ? `${_find.age} años`
                            : "Edad no disponible")
                        : "",
                    "Porcentaje de descuento": isFirst
                        ? (
                            (
                                _find?.nameCommont === "Descuento Especial"
                                    ? _find?.amountPercentag1
                                    : _find?.amountPercentag
                            ) != null
                                ? `${_find?.nameCommont === "Descuento Especial"
                                    ? _find?.amountPercentag1
                                    : _find?.amountPercentag}%`
                                : "N/A"
                        )
                        : "",
                    "Usuario que realizo admisión": isFirst
                        ? (_find?.user ?? "")
                        : "",
                    "Estatus": _find?.status ?? "",
                    "Nombre": patientName,
                    "Médico": _find?.doctorName || "",
                    "Compañia": isFirst
                        ? (_find?.type || "Público General")
                        : "",
                    "Nombre de la empresa": isFirst
                        ? (_find?.type === "Empresas"
                            ? (_find?.name_company ?? "")
                            : "N/A")
                        : "",
                    "Estudio": estudio?.name || "Sin estudio",
                    "Subtotal": Number(estudio?.price ?? 0),
                    "IVA": Number(estudio?.price_tax ?? 0),
                    "Descuento": Number(estudio?.total_discount ?? 0),
                    "Urgencia": Number(estudio?.price_urgent ?? 0),
                    "Total": Number(estudio?.total ?? 0),
                    "Estatus del estudio": estudio?.status_exam || "N/A",
                    "Estado de pago": _find?.is_fullPaid ?? ""
                };

                _Report.push(reportObject);
            });
        });


        const exportReport = _Report.map(item => {
            const { _isAjuste, ...rest } = item;
            return rest;
        });

        const branchName =
            _array?.length > 0
                ? (
                    _array.every(item =>
                        item?.name_branches === _array[0]?.name_branches
                    )
                        ? (_array[0]?.name_branches ?? "Todas las sucursales")
                        : "Varias sucursales"
                )
                : "Todas las sucursales";


        const worksheet = XLSX.utils.aoa_to_sheet([

            ["REPORTE GLOBAL"],

            ["Reporte detallado de ingresos, estudios y movimientos"],

            [
                `SUCURSAL: ${branchName}`,
                "", "", "", "",
                "", "", "", "", ""
            ],

            [],

            // [
            //     "TOTAL GLOBAL", "",
            //     "TOTAL CON CRÉDITO", "",
            //     "MOVIMIENTOS", "",
            //     "DESCUENTOS", "",
            //     "CANCELACIONES", "",
            //     "SALDO RECUPERADO", ""
            // ],
            // [
            //     totalAmount, "",
            //     totalAmount + totalCredit, "",
            //     totalDiscount, "",
            //     totalCanceled, "",
            //     totalRecovered, "",
            //     _array.length, "",

            // ],
            [
                "TOTAL GLOBAL", "",
                "TOTAL CON CRÉDITO", "",
                "SALDO RECUPERADO", "",
                "DESCUENTOS", "",
                "CANCELACIONES", "",
                "MOVIMIENTOS", "",

            ],
            [
                totalAmount, "",
                (totalAmount + totalCredit), "",
                totalRecovered, "",
                totalDiscount, "",
                totalCanceled, "",
                dataReport.length, "",

            ],

            [],

            [
                "EFECTIVO", "",
                "TARJETA DE CRÉDITO", "",
                "TARJETA DE DÉBITO", "",
                "CRÉDITO", "",
                "TRANSFERENCIA", ""
            ],

            [
                totalCash, "",
                totalCreditCard, "",
                totalDebitCard, "",
                totalCredit, "",
                totalTransfer, ""
            ],

            [],

            ["DETALLE DE MOVIMIENTOS"]
        ]);

        // ============================================
        // 4. COMBINAR CELDAS DEL DASHBOARD
        // ============================================
        worksheet["!merges"] = [

            // Títulos principales
            { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 11 } },

            // Sucursal
            { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
            { s: { r: 2, c: 6 }, e: { r: 2, c: 11 } },

            // Etiquetas de indicadores
            { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } },
            { s: { r: 4, c: 2 }, e: { r: 4, c: 3 } },
            { s: { r: 4, c: 4 }, e: { r: 4, c: 5 } },
            { s: { r: 4, c: 6 }, e: { r: 4, c: 7 } },
            { s: { r: 4, c: 8 }, e: { r: 4, c: 9 } },
            { s: { r: 4, c: 10 }, e: { r: 4, c: 11 } },

            // Valores de indicadores
            { s: { r: 5, c: 0 }, e: { r: 5, c: 1 } },
            { s: { r: 5, c: 2 }, e: { r: 5, c: 3 } },
            { s: { r: 5, c: 4 }, e: { r: 5, c: 5 } },
            { s: { r: 5, c: 6 }, e: { r: 5, c: 7 } },
            { s: { r: 5, c: 8 }, e: { r: 5, c: 9 } },
            { s: { r: 5, c: 10 }, e: { r: 5, c: 11 } },

            // Métodos de pago
            { s: { r: 7, c: 0 }, e: { r: 7, c: 1 } },
            { s: { r: 7, c: 2 }, e: { r: 7, c: 3 } },
            { s: { r: 7, c: 4 }, e: { r: 7, c: 5 } },
            { s: { r: 7, c: 6 }, e: { r: 7, c: 7 } },
            { s: { r: 7, c: 8 }, e: { r: 7, c: 9 } },

            { s: { r: 8, c: 0 }, e: { r: 8, c: 1 } },
            { s: { r: 8, c: 2 }, e: { r: 8, c: 3 } },
            { s: { r: 8, c: 4 }, e: { r: 8, c: 5 } },
            { s: { r: 8, c: 6 }, e: { r: 8, c: 7 } },
            { s: { r: 8, c: 8 }, e: { r: 8, c: 9 } },

            // Título del detalle: A hasta AC (29 columnas)
            { s: { r: 10, c: 0 }, e: { r: 10, c: 28 } }
        ];

        XLSX.utils.sheet_add_json(
            worksheet,
            exportReport,
            {
                origin: "A12"
            }
        );


        const navy = "1B4F72";
        const blue = "1B658B";
        const lightBlue = "EFF7FD";
        const lightGray = "F1F5F8";
        const white = "FFFFFF";
        const green = "166534";
        const borderColor = "D9E2F3";

        const moneyFormat = '$#,##0.00;[Red]-$#,##0.00';

        const setCellStyle = (address, style) => {

            if (!worksheet[address]) {
                worksheet[address] = {
                    t: "s",
                    v: ""
                };
            }

            worksheet[address].s = style;
        };


        setCellStyle("A1", {
            font: {
                bold: true,
                sz: 20,
                color: { rgb: navy }
            },
            alignment: {
                vertical: "center"
            }
        });

        setCellStyle("A2", {
            font: {
                sz: 10,
                color: { rgb: "64748B" }
            },
            alignment: {
                vertical: "center"
            }
        });

        setCellStyle("A3", {
            font: {
                bold: true,
                sz: 9,
                color: { rgb: navy }
            },
            alignment: {
                vertical: "center"
            }
        });


        const cards = [
            { label: "A5", value: "A6", dark: true, format: moneyFormat },
            { label: "C5", value: "C6", dark: false, format: moneyFormat },
            { label: "E5", value: "E6", dark: false, format: moneyFormat },
            { label: "G5", value: "G6", dark: false, format: moneyFormat },
            { label: "I5", value: "I6", dark: false, format: moneyFormat },
            { label: "K5", value: "K6", dark: false, format: "0" },
        ];


        cards.forEach(card => {

            const background = card.dark ? navy : lightGray;
            const foreground = card.dark ? white : navy;

            const baseStyle = {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: background }
                },
                alignment: {
                    vertical: "center",
                    horizontal: "left"
                }
            };

            setCellStyle(card.label, {
                ...baseStyle,
                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: foreground }
                }
            });

            setCellStyle(card.value, {
                ...baseStyle,
                font: {
                    bold: true,
                    sz: 16,
                    color: { rgb: foreground }
                },
                numFmt: card.format
            });
        });


        const paymentCells = [
            { label: "A8", value: "A9" },
            { label: "C8", value: "C9" },
            { label: "E8", value: "E9" },
            { label: "G8", value: "G9" },
            { label: "I8", value: "I9" }
        ];

        paymentCells.forEach(item => {

            setCellStyle(item.label, {
                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: navy }
                },
                alignment: {
                    vertical: "center"
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: borderColor }
                    }
                }
            });

            setCellStyle(item.value, {
                font: {
                    bold: true,
                    sz: 11,
                    color: { rgb: green }
                },
                numFmt: moneyFormat,
                alignment: {
                    vertical: "center"
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: borderColor }
                    }
                }
            });
        });


        const detailHeaderRow = 11;
        const detailRange = XLSX.utils.decode_range(worksheet["!ref"]);

        for (
            let col = detailRange.s.c;
            col <= detailRange.e.c;
            col++
        ) {

            const address = XLSX.utils.encode_cell({
                r: detailHeaderRow,
                c: col
            });

            setCellStyle(address, {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: blue }
                },
                font: {
                    bold: true,
                    color: { rgb: white },
                    sz: 9
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: borderColor }
                    }
                }
            });
        }


        _Report.forEach((reportItem, index) => {

            if (reportItem?._isAjuste) {

                const excelRow = index + 12;

                for (
                    let col = detailRange.s.c;
                    col <= detailRange.e.c;
                    col++
                ) {

                    const address = XLSX.utils.encode_cell({
                        r: excelRow,
                        c: col
                    });

                    const cell = worksheet[address];

                    if (cell) {
                        cell.s = {
                            ...(cell.s || {}),
                            fill: {
                                patternType: "solid",
                                fgColor: { rgb: lightBlue }
                            }
                        };
                    }
                }
            }
        });

        const totalRow = {

            "Solicitud(NIM)": "",
            "Fecha": "",
            "Hora": "",
            "Sucursal": "",
            "Efectivo": totalCash,
            "Credito": totalCredit,
            "Tarjeta de Crédito": totalCreditCard,
            "Tarjeta de Debito": totalDebitCard,
            "Transferencia": totalTransfer,
            "Total orden": totalAmount,
            "Total S.R": totalRecovered,
            "Usuario S.R.": "",
            "Tipo de descuento": "",
            "Edad": "",
            "Porcentaje de descuento": "",
            "Usuario que realizo admisión": "",
            "Estatus": "",
            "Nombre": "",
            "Médico": "",
            "Compañia": "",
            "Nombre de la empresa": "",
            "Estudio": "",
            "Subtotal": "",
            "IVA": "",
            "Descuento": totalDiscount,
            "Urgencia": "",
            "Total": "",
            "Estatus del estudio": "",
            "Estado de pago": ""
        };

        XLSX.utils.sheet_add_json(
            worksheet,
            [totalRow],
            {
                skipHeader: true,
                origin: -1
            }
        );

        const finalRange = XLSX.utils.decode_range(worksheet["!ref"]);
        const totalExcelRow = finalRange.e.r;

        for (
            let col = finalRange.s.c;
            col <= finalRange.e.c;
            col++
        ) {

            const address = XLSX.utils.encode_cell({
                r: totalExcelRow,
                c: col
            });

            setCellStyle(address, {
                font: {
                    bold: true,
                    color: { rgb: navy }
                },
                border: {
                    top: {
                        style: "medium",
                        color: { rgb: blue }
                    }
                }
            });
        }


        const moneyColumns = [
            "E", "F", "G", "H", "I",
            "J", "K",
            "W", "X", "Y", "Z", "AA"
        ];

        moneyColumns.forEach(column => {

            for (let row = 12; row <= totalExcelRow; row++) {

                const address = `${column}${row}`;

                if (worksheet[address] &&
                    typeof worksheet[address].v === "number") {

                    worksheet[address].s = {
                        ...(worksheet[address].s || {}),
                        numFmt: moneyFormat
                    };
                }
            }
        });


        worksheet["!cols"] = [
            { wch: 18 },
            { wch: 14 },
            { wch: 12 },
            { wch: 20 },
            { wch: 16 },
            { wch: 16 },
            { wch: 19 },
            { wch: 19 },
            { wch: 17 },
            { wch: 17 },
            { wch: 17 },
            { wch: 25 },
            { wch: 23 },
            { wch: 18 },
            { wch: 22 },
            { wch: 28 },
            { wch: 16 },
            { wch: 30 },
            { wch: 25 },
            { wch: 20 },
            { wch: 28 },
            { wch: 35 },
            { wch: 16 },
            { wch: 14 },
            { wch: 16 },
            { wch: 16 },
            { wch: 16 },
            { wch: 22 },
            { wch: 18 }
        ];


        worksheet["!rows"] = [
            { hpt: 30 },
            { hpt: 18 },
            { hpt: 20 },
            { hpt: 8 },
            { hpt: 22 },
            { hpt: 32 },
            { hpt: 8 },
            { hpt: 20 },
            { hpt: 24 },
            { hpt: 8 },
            { hpt: 25 },
            { hpt: 32 }
        ];


        setCellStyle("A11", {
            fill: {
                patternType: "solid",
                fgColor: { rgb: navy }
            },
            font: {
                bold: true,
                sz: 12,
                color: { rgb: white }
            },
            alignment: {
                horizontal: "left",
                vertical: "center"
            }
        });


        worksheet["!freeze"] = {
            xSplit: 0,
            ySplit: 12,
            topLeftCell: "A13",
            activePane: "bottomLeft",
            state: "frozen"
        };


        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Reporte Global"
        );

        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: "xlsx",
                type: "array"
            }
        );

        const dataBlob = new Blob(
            [excelBuffer],
            {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );

        const fileName = "Reporte Global con estudios.xlsx";

        if (
            typeof window !== "undefined" &&
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) {

            window.navigator.msSaveOrOpenBlob(
                dataBlob,
                fileName
            );

        } else {

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }
    }

    function exportToExcelWithoutExamsLabcen(nimDataExcel) {
        let _Report = [];
        let _array = nimDataExcel ?? [];

        let totalAmount = 0;
        let totalCash = 0;
        let totalCredit = 0;
        let totalCreditCard = 0;
        let totalDebitCard = 0;
        let totalTransfer = 0;
        let totalDiscount = 0;
        let totalCanceled = 0;
        let totalRecovered = 0;


        _array.forEach((_find) => {
            const isCanceled =
                String(_find?.status ?? "").toLowerCase() === "cancelado";

            const amount = Number(_find?.amount ?? 0);
            const amountAdjust = Number(_find?.amount_is_adjust ?? 0);
            const amountDiscount = Number(_find?.amountDiscount ?? 0);

            const _a = "Solicitud(NIM)";

            if (!isCanceled) {
                totalAmount += amount;

                totalCash += Number(_find?.cash ?? 0);
                totalCredit += Number(_find?.credit ?? 0);
                totalCreditCard += Number(_find?.creditCard ?? 0);
                totalDebitCard += Number(_find?.debitCard ?? 0);
                totalTransfer += Number(_find?.electronicTransfer ?? 0);

                totalDiscount += amountDiscount;
                totalRecovered += amountAdjust;
            } else {
                totalCanceled += amount;
            }

            const reportObject = {
                _isAjuste: _find?.ajuste === true,
                [_a]: _find?.nim,
                "Fecha": _find?.fech_admision,
                "Hora": _find?.hour,
                "Sucursal": _find?.name_branches,
                "Efectivo": Number(_find?.cash ?? 0),
                "Credito": Number(_find?.credit ?? 0),
                "Tarjeta de Crédito": Number(_find?.creditCard ?? 0),
                "Tarjeta de Debito": Number(_find?.debitCard ?? 0),
                "Transferencia": Number(_find?.electronicTransfer ?? 0),
                "Total": amount,
                "Total S.R": amountAdjust,
                "Usuario S.R.": _find?.nameUserAdjust ?? "",
                "Monto de devolucion": _find?.amount_devolution ?? 0,
                "Método de devolucion": _find?.name_devolution ?? 0,
                "Motivo de devolucion": _find?.name_reason_devolution ?? 0,
                "Tipo de descuento":
                    _find?.name_Preloaded_discount !== ""
                        ? _find?.name_Preloaded_discount
                        : _find?.nameCommont !== ""
                            ? _find?.nameCommont
                            : "N/A",
                "Edad": _find?.age ? `${_find.age} años` : "Edad no disponible",
                "Porcentaje de descuento":
                    _find?.nameCommont === "Descuento Especial"
                        ? `${_find?.amountPercentag1 ?? "N/A"}%`
                        : `${_find?.amountPercentag ?? "N/A"}%`,
                "Usuario que realizo admisión": _find?.user ?? "",
                "Estatus": _find?.status ?? "",
                "Nombre": _find?.namePatiente ?? "",
                "Compañia": _find?.type ?? "",
                "Estado de pago": _find?.is_fullPaid ?? "",

            };

            _Report.push(reportObject);
        });

        const exportReport = _Report.map(item => {
            const { _isAjuste, ...rest } = item;
            return rest;
        });


        const branchName = _array?.[0]?.name_branches ?? "Todas las sucursales";


        const worksheet = XLSX.utils.aoa_to_sheet([
            ["REPORTE GLOBAL"],
            ["Reporte detallado de ingresos y movimientos"],
            [
                `SUCURSAL: ${branchName}`,
                "", "", "", "", "", "", "", "", ""
            ],
            [],
            [
                "TOTAL GLOBAL", "",
                "TOTAL CON CRÉDITO", "",
                "SALDO RECUPERADO", "",
                "DESCUENTOS", "",
                "CANCELACIONES", "",
                "MOVIMIENTOS", "",

            ],
            [
                totalAmount, "",
                (totalAmount + totalCredit), "",
                totalRecovered, "",
                totalDiscount, "",
                totalCanceled, "",
                dataReport.length, "",

            ],
            [],
            [
                "EFECTIVO", "",
                "TARJETA DE CRÉDITO", "",
                "TARJETA DE DÉBITO", "",
                "CRÉDITO", "",
                "TRANSFERENCIA", ""
            ],
            [
                totalCash, "",
                totalCreditCard, "",
                totalDebitCard, "",
                totalCredit, "",
                totalTransfer, ""
            ],
            [],
            ["DETALLE DE MOVIMIENTOS"]
        ]);

        // ============================================
        // 3. COMBINAR CELDAS DEL DASHBOARD
        // ============================================
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 11 } },

            { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
            { s: { r: 2, c: 6 }, e: { r: 2, c: 11 } },

            // Etiquetas de indicadores
            { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } },
            { s: { r: 4, c: 2 }, e: { r: 4, c: 3 } },
            { s: { r: 4, c: 4 }, e: { r: 4, c: 5 } },
            { s: { r: 4, c: 6 }, e: { r: 4, c: 7 } },
            { s: { r: 4, c: 8 }, e: { r: 4, c: 9 } },
            { s: { r: 4, c: 10 }, e: { r: 4, c: 11 } },

            // Valores de indicadores
            { s: { r: 5, c: 0 }, e: { r: 5, c: 1 } },
            { s: { r: 5, c: 2 }, e: { r: 5, c: 3 } },
            { s: { r: 5, c: 4 }, e: { r: 5, c: 5 } },
            { s: { r: 5, c: 6 }, e: { r: 5, c: 7 } },
            { s: { r: 5, c: 8 }, e: { r: 5, c: 9 } },
            { s: { r: 5, c: 10 }, e: { r: 5, c: 11 } },

            // Métodos de pago
            { s: { r: 7, c: 0 }, e: { r: 7, c: 1 } },
            { s: { r: 7, c: 2 }, e: { r: 7, c: 3 } },
            { s: { r: 7, c: 4 }, e: { r: 7, c: 5 } },
            { s: { r: 7, c: 6 }, e: { r: 7, c: 7 } },
            { s: { r: 7, c: 8 }, e: { r: 7, c: 9 } },
            { s: { r: 7, c: 10 }, e: { r: 7, c: 11 } },

            { s: { r: 8, c: 0 }, e: { r: 8, c: 1 } },
            { s: { r: 8, c: 2 }, e: { r: 8, c: 3 } },
            { s: { r: 8, c: 4 }, e: { r: 8, c: 5 } },
            { s: { r: 8, c: 6 }, e: { r: 8, c: 7 } },
            { s: { r: 8, c: 8 }, e: { r: 8, c: 9 } },
            { s: { r: 8, c: 10 }, e: { r: 8, c: 11 } },
        ];


        XLSX.utils.sheet_add_json(
            worksheet,
            exportReport,
            {
                origin: "A12"
            }
        );



        const navy = "1B4F72";
        const blue = "1B658B";
        const lightBlue = "EFF7FD";
        const lightGray = "F1F5F8";
        const white = "FFFFFF";
        const green = "166534";
        const borderColor = "D9E2F3";

        const moneyFormat = '$#,##0.00;[Red]-$#,##0.00';

        const setCellStyle = (address, style) => {
            if (!worksheet[address]) {
                worksheet[address] = {
                    t: "s",
                    v: ""
                };
            }

            worksheet[address].s = style;
        };


        setCellStyle("A1", {
            font: {
                bold: true,
                sz: 20,
                color: { rgb: navy }
            },
            alignment: {
                vertical: "center"
            }
        });

        setCellStyle("A2", {
            font: {
                sz: 10,
                color: { rgb: "64748B" }
            }
        });

        setCellStyle("A3", {
            font: {
                bold: true,
                sz: 9,
                color: { rgb: navy }
            },
            alignment: {
                vertical: "center"
            }
        });

        setCellStyle("E3", {
            font: {
                bold: true,
                sz: 9,
                color: { rgb: navy }
            },
            alignment: {
                horizontal: "right",
                vertical: "center"
            }
        });



        const cards = [
            { label: "A5", value: "A6", dark: true, format: moneyFormat },
            { label: "C5", value: "C6", dark: false, format: moneyFormat },
            { label: "E5", value: "E6", dark: false, format: moneyFormat },
            { label: "G5", value: "G6", dark: false, format: moneyFormat },
            { label: "I5", value: "I6", dark: false, format: moneyFormat },
            { label: "K5", value: "K6", dark: false, format: "0" },
        ];

        cards.forEach(card => {
            const background = card.dark ? navy : lightGray;
            const foreground = card.dark ? white : navy;

            const baseStyle = {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: background }
                },
                alignment: {
                    vertical: "center",
                    horizontal: "left"
                }
            };

            setCellStyle(card.label, {
                ...baseStyle,
                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: foreground }
                }
            });

            setCellStyle(card.value, {
                ...baseStyle,
                font: {
                    bold: true,
                    sz: 16,
                    color: { rgb: foreground }
                },
                numFmt: card.format
            });
        });


        const paymentCells = [
            { label: "A8", value: "A9" },
            { label: "C8", value: "C9" },
            { label: "E8", value: "E9" },
            { label: "G8", value: "G9" },
            { label: "I8", value: "I9" },
            { label: "K8", value: "K9" }

        ];

        paymentCells.forEach(item => {
            setCellStyle(item.label, {
                font: {
                    bold: true,
                    sz: 9,
                    color: { rgb: navy }
                },
                alignment: {
                    vertical: "center"
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: borderColor }
                    }
                }
            });

            setCellStyle(item.value, {
                font: {
                    bold: true,
                    sz: 11,
                    color: { rgb: green }
                },
                numFmt: moneyFormat,
                alignment: {
                    vertical: "center"
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: borderColor }
                    }
                }
            });
        });


        const detailHeaderRow = 11;
        const detailRange = XLSX.utils.decode_range(worksheet["!ref"]);

        for (let col = detailRange.s.c; col <= detailRange.e.c; col++) {
            const address = XLSX.utils.encode_cell({
                r: detailHeaderRow,
                c: col
            });

            setCellStyle(address, {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: "DCEAF5" }
                },
                font: {
                    bold: true,
                    color: { rgb: "1B4F72" },
                    sz: 10
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true
                },
                border: {
                    bottom: {
                        style: "medium",
                        color: { rgb: "1B658B" }
                    }
                }
            });
        }

        _Report.forEach((reportItem, index) => {
            if (reportItem?._isAjuste) {
                const excelRow = index + 12;

                for (let col = detailRange.s.c; col <= detailRange.e.c; col++) {
                    const address = XLSX.utils.encode_cell({
                        r: excelRow,
                        c: col
                    });

                    const cell = worksheet[address];

                    if (cell) {
                        cell.s = {
                            ...(cell.s || {}),
                            fill: {
                                patternType: "solid",
                                fgColor: { rgb: lightBlue }
                            }
                        };
                    }
                }
            }
        });


        const totalRow = {
            "Solicitud(NIM)": "",
            "Fecha": "",
            "Hora": "",
            "Sucursal": "",
            "Efectivo": totalCash,
            "Credito": totalCredit,
            "Tarjeta de Crédito": totalCreditCard,
            "Tarjeta de Debito": totalDebitCard,
            "Transferencia": totalTransfer,
            "Total": totalAmount,
            "Total de saldo recuperado": totalRecovered,
            "Usuario que realizo recuperación": "",
            "Monto de devolucion": "",
            "Método de devolucion": "",
            "Motivo de devolucion": "",
            "Tipo de descuento": "",
            "Edad": "",
            "Porcentaje de descuento": "",
            "Usuario que realizo admisión": "",
            "Estatus": "",
            "Nombre": "",
            "Compañia": "",
            "Estado de pago": "",
        };



        XLSX.utils.sheet_add_json(
            worksheet,
            [totalRow],
            {
                skipHeader: true,
                origin: -1
            }
        );

        const finalRange = XLSX.utils.decode_range(worksheet["!ref"]);
        const totalExcelRow = finalRange.e.r;

        for (let col = finalRange.s.c; col <= finalRange.e.c; col++) {
            const address = XLSX.utils.encode_cell({
                r: totalExcelRow,
                c: col
            });

            setCellStyle(address, {
                font: {
                    bold: true,
                    color: { rgb: navy }
                },
                border: {
                    top: {
                        style: "medium",
                        color: { rgb: blue }
                    }
                }
            });
        }


        worksheet["!cols"] = [
            { wch: 20 },
            { wch: 14 },
            { wch: 14 },
            { wch: 20 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 22 },
            { wch: 30 },
            { wch: 22 },
            { wch: 14 },
            { wch: 20 },
            { wch: 28 },
            { wch: 16 },
            { wch: 30 },
            { wch: 22 },
            { wch: 20 }
        ];

        worksheet["!rows"] = [
            { hpt: 30 },
            { hpt: 18 },
            { hpt: 20 },
            { hpt: 8 },
            { hpt: 22 },
            { hpt: 32 },
            { hpt: 8 },
            { hpt: 20 },
            { hpt: 24 },
            { hpt: 8 },
            { hpt: 25 },
            { hpt: 32 }
        ];

        // Encabezado DETALLE DE MOVIMIENTOS
        setCellStyle("A11", {
            fill: {
                patternType: "solid",
                fgColor: { rgb: "1B4F72" }
            },
            font: {
                bold: true,
                sz: 12,
                color: { rgb: "FFFFFF" }
            },
            alignment: {
                horizontal: "left",
                vertical: "center"
            }
        });


        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Reporte Global"
        );

        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: "xlsx",
                type: "array"
            }
        );

        const dataBlob = new Blob(
            [excelBuffer],
            {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );



        const fileName = "Reporte Global sin estudios.xlsx";

        if (
            typeof window !== "undefined" &&
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) {
            window.navigator.msSaveOrOpenBlob(
                dataBlob,
                fileName
            );
        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }
    }




    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 404) {

            createSweet("info", "info", "Atención", response.data.msg);
        }
        else if (response.code === 500) {
        }
        else {
        }
        return null;
    }

    const cancelTabChange = () => {

        setShowAlert(false);

    };
    const cancelTabChange2 = () => {

        setShowAlert2(false);

    };



    return {
        //*CONFIGURATION CASH
        navigatePrev, viewTab, formCash, capture_amount, handleInputChangeCash, loading,

        //*INDICATORS
        cancell, discountT, comments, saveCreate, formatter, totalCancell, totalPatients,

        //*HISTORIC
        dataHistoric, dateInit, dateEnd, changeDate, handleHistoric, previewCash, toggleCash, typeModal, modalC, typeAmoun, amountfin,

        //*FINAL REPORT
        dataReport, modalFullRef, handleReport, close, modalProps, totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1, dataPaymets, dataCancell,
        dataDiscount, dataPatient, dataDevolution, mDateRange1, mDateRange2, getReport, mSelectBranch, handleSelectValuesCash,
        printCashClosing, branches, totalPaymets, exportToExcel,

        //*FINAL REPORT TYPE COMPANY
        type_company, handleClean, dataMDiscount, dataUser, ids_users, number_format, sumPayMethods,

        //*PRINT TICKETS
        modalPrint, toggleModalPrint, handleViewTickets, printTicket, loadingPrint, loadingCreate,

        //*PREVIEW PRINT 
        modalPreview, toggleModalPreview, handleViewPreview, downloadExcel,

        // ? CONFIGURATION
        _type_client, total_devolution, downloadExcelCredits, downloadExcelOthers,

        dataUserReport,

        globalFilter, setGlobalFilter,

        _commercialLine, _nameUser, _branchName, excelExport, setExcelExport,
        loadingReport, exportToExcel2, getBadgePatient, getBadgeStatus, handleNim, customBody,
        visibleTicket, showModalTicket, hideModalTicket,
        exportToExcelWithoutExams,

        showAlert, cancelTabChange, showAlert2, cancelTabChange2,
        showToast, toastType, toastTitle, toastMessage, closeToastAlert,
        dataBonificacionCC,
        exportToExcelLabcen,
        labcen,
        exportToExcelWithoutExamsLabcen



    }
}


